import { fieldSchemaMessages } from "@thalamos/common";

const values = {
  endIncidentPreTriage: {
    title: "End Form",
    warningBanner:
      "This process is irreversible. You won't be able to edit the form once completed.",
    return: "Return",
    endForm: "End Form",
    confirmToast: "Incident ended successfully",
    errorToast: "Error ending incident",
    noIncidentIdError: "Incident ID is required to proceed.",
  },
  fieldSchema: {
    // Wording for the keys the shared field schemas emit travels with them, so a
    // schema added there cannot arrive here without words.
    ...fieldSchemaMessages,
    dispatchNumber: {
      tooShort: "$t(common.dispatchNumber) must be at least 4 characters",
      required: "Please enter the $t(common.dispatchNumber) for this incident",
    },
  },
  role: {
    officer: "Officer",
    commandunit: "Command Unit",
    supervisor: "Supervisor",
    clientAdmin: "Client Admin",
    analyticsViewer: "Analytics Viewer",
    guestUser: "Guest User",
  },
  trainingBanner: {
    content:
      "Welcome! You are signed into a training environment of Thalamos digital Mental Health Forms (MH Forms) Solution. Some functionality may be reduced. Do not use this environment for real patient data.",
  },
  navigation: {
    home: "Home",
    newIncident: "New Incident",
    inProgressIncidents: "In-progress Incidents",
    endedIncidents: "Ended Incidents",
    help: "Help",
    notifications: "Notifications",
    logout: "Logout",
    admin: "Admin",
    endedForms: "Ended Forms",
    changeRole: "Change role >",
    policyHelp: "Policy Help",
  },
  login: {
    loginToAccess: "Click login to access MH Forms",
    login: "Login",
  },
  common: {
    dispatchNumber: "Dispatch Number",
    shoulderNumber: "Shoulder Number",
    yes: "Yes",
    no: "No",
    other: "Other",
    close: "Close",
    download: "Download",
    finish: "Finish",
    unknown: "Unknown",
    required: "Required",
    search: "Search",
    cancel: "Cancel",
    confirm: "Confirm",
  },
  formBuilder: {
    officerLookup: {
      placeholder: "Search by name, email or $t(common.shoulderNumber)",
      shoulderNumber: "$t(common.shoulderNumber)",
      officerName: "Name",
      email: "Email",
      confirmationLabel: "I confirm that the details above are correct",
      notFoundHeading: "Officer not found",
      notFoundDetail:
        "No officer was found with those details. You can still confirm and proceed if you believe the $t(common.shoulderNumber) is correct.",
      confirmationLabelNotFound:
        "I confirm that this $t(common.shoulderNumber) is correct",
    },
  },
  archivePage: {
    title: "Ended Forms",
    noFormsCompleted: "No Forms Completed",
    noFormsCompletedMessage: "You currently have no completed forms.",
    endedFormsAvailablity:
      "Forms will be auto-closed and deleted 3 months after the form was created. To keep a copy of the form, please end your form and download the PDF within 3 months.",
  },
  multiPageForm: {
    pageProgressLabel: "Page progress",
    next: "Next",
    cancel: "Cancel",
    storybook: {
      playerName: "What's your name? [This is an optional field]",
      playerNameWithCount:
        "[This field is expandable, with dynamic content, and using advanced features of the translation library]",
      playerNameWithCount_one:
        "Your name contains {{count}} letter. [This field is expandable, with dynamic content, and using advanced features of the translation library]",
      playerNameWithCount_other:
        "Your name contains {{count}} letters. [This field is expandable, with dynamic content, and using advanced features of the translation library]",
      wouldYouLikeToPlayAGame:
        "Would you like to play a game? (yes/no) [This is a branching question]",
      wouldYouLikeToPlayAGameEncourage:
        "Games are fun and are good for your mental health. [This 'readonly' field always appears]",
      whatKindOfGame:
        "What kind of game do you want to play? (number/word) [This reveals different fields on a page]",
      numberGameLowNumber: "Pick a number, any number.",
      numberGameHighNumber:
        "Pick a number, higher than the previous number. [This shows on-page validation between fields]",
      numberGameMuchHigher:
        "Wow that is a much higher number! [This conditionally appears and is based on the previous field]",
      wordGamePhrase: "What is a word you struggle to spell?",
      whyDontYouWantToPlayAGame: "Why don't you want to play a game?",
      wouldYouLikeToPlayAGameShame:
        "Shame! Feel free to press the back arrow if you change your mind. [This 'readonly' field conditionally appears]",
      didYouEnjoyTheGame:
        "Did you enjoy the game? [This page only appears if you played the game]",
      willYouConsiderPlayingAnotherTime:
        "Will you consider playing again another time? (yes/no) [We converge here irrespective of the branch taken at the start]",
      availableGames:
        "The following games are available: <ul><li>Number guessing</li><li>Word puzzles</li><li>Strategy challenges</li></ul>",
    },
  },
  incidentBanner: {
    viewShareForm: "Share Form",
    viewTimeline: "View Timeline",
    personName: "Name of Person",
    incidentStatus: "Incident Status",
    viewPdf: "View PDF",
  },
  incidentWorkItem: {
    startNew: "Start new incident form",
    section136: "Section 136",
    mca: "MCA",
    voluntary: "Voluntary",
    newForm: "New Form",
    nameOfPerson: "Name of person",
    typeOfIncident: "Type of incident",
    createdAt: "Created at",
    commandUnit: "Command Unit",
    geographicUnit: "Geographic Unit ID",
    currentAssignee: "Officer Assigned",
    view: "View",
    acceptTransfer: "Accept Transfer",
    cancel: "Cancel",
    reject: "Reject",
    formInProgress: "Form in progress",
    arrivedAtPlaceOfSafety: "Arrived at POS",
    arrivedAtPlaceOfSafety_136: "Arrived at POS",
    arrivedAtPlaceOfSafety_mca: "Arrived at ED",
    awaitingArrival: "Awaiting Arrival",
    formShared: "Form shared",
    formAccessed: "Form accessed",
    policePresenceRequested: "Police support requested",
    policePresenceNotRequested: "Police free to leave",
    formStatusUnknown: "Unknown",
    formEnded: "Form ended",
    formAutoClosed: "Form auto-closed",
    pendingTransfer: "Pending Transfer",
    unknownOwner: "Unknown",
    type: {
      "136": "Section 136",
      mca: "MCA",
      voluntary: "Voluntary",
      other: "Other",
    },
    notificationAcceptedShow: "Section 136 incident accepted",
    notificationAcceptedError: "Error accepting Section 136 incident",
    pdfNotAvailableTitle: "This form has no PDF yet",
    pdfNotAvailableBody:
      "A PDF is produced once the incident triage has been completed.",
    transferAccepted:
      "{{officerName}} has accepted the transfer, so you no longer have access to this form.",
    transferAcceptedUnknownOfficer:
      "The transfer has been accepted, so you no longer have access to this form.",
    noLongerEndable: "You can no longer end this form.",
    notificationCancelledShow: "Transfer cancelled successfully",
    notificationCancelledError: "Error cancelling transfer",
    notificationRejectedShow: "Transfer was rejected successfully",
    notificationRejectedError: "Error rejecting transfer",
    notificationFailedToSave:
      "Save failed.\nPlease check your network connection and try again.",
    myIncidents: "My Incidents",
    transferredIncidents: "Transferred Incidents",
    yourIncidentsHere: "Your incidents will show here",
    transferredIncidentsHere: "Transferred Incidents will show here",
  },

  createIncident: {
    newIncidentForm: "New Incident Form",
    dispatchNumber: {
      label: "$t(common.dispatchNumber) - Please enter CAD reference only",
      placeholder: "e.g. 1234",
    },
    dispatchNumberCreated: "$t(common.dispatchNumber) creation date",
    dispatchNumberCreatedRequired:
      "Please enter the date the $t(common.dispatchNumber) for this incident was created",
    dispatchNumberCreatedDate: "Date of $t(common.dispatchNumber) creation",
    dispatchNumberCreatedTime: "Time of $t(common.dispatchNumber) creation",
    incidentLocation: "Location where incident took place",
    incidentLocationRequired:
      "Please enter the location of the incident and use the checkbox to indicate if outside of an address",
    incidentLocationBanner:
      "Location can only be used in a public place. Please edit the address to best describe the location of the incident",
    userIsAttendingOfficer: "Were you the attending/responding officer?",
    createdOnBehalfOfAnotherOfficerWithShoulderNumber:
      "Please confirm the $t(common.shoulderNumber) of the responsible officer",
    createdOnBehalfOfAnotherOfficerBanner:
      "Please note, the responsible officer will not have access to this form unless you transfer the form to them. You can transfer the form to them on the 'Incident Overview Page'.",
    personForename: "Person's forename(s)",
    personForenameRequired: "Please provide the person's forename(s)",
    personSurname: "Person's surname",
    personSurnameRequired: "Please provide the person's surname",
    commandUnit:
      "In which $t(incidentWorkItem.commandUnit) did the incident happen?",
    commandUnitRequired:
      "Please select the $t(incidentWorkItem.commandUnit) in which this detention occurred",
    geographicUnit: "$t(incidentWorkItem.geographicUnit)",
    invalidGeographicUnit:
      "$t(incidentWorkItem.geographicUnit) not found. Please make a selection from the dropdown list",
    outsideAboveAddress: "Outside above address",
  },
  incidentFormSections: {
    incident: "Incident created",
    triage: "Triage",
    incidentAndTriage: "Incident Triage",
    detention: "Detention details",
    person: "Person details",
    information: "Information for Healthcare",
    endForm: "End Form",
    mcaPersonDetails: "Person details",
    mcaIncidentDetails: "Incident details",
    mcaCapacityAssessment: "Capacity assessment",
    mcaAccompaniment: "Accompaniment to Emergency Department",
  },
  sharePage: {
    title: "Share & Handover",
    shareWith: "Share with:",
    shareByEmail: "Share by email",
    sendFormsViaEmail: "Send forms to Place of Safety via email",
    sendFormsViaEmail_136: "Send forms to Place of Safety via email",
    sendFormsViaEmail_mca: "Send forms to Emergency Department via email",
    otherOptions: "Other options",
    shareWithoutEmailOption: "Share without email",
    posUniqueCode: "Place of Safety can access forms through unique share code",
    posUniqueCode_136:
      "Place of Safety can access forms through unique share code",
    posUniqueCode_mca:
      "Emergency Department can access forms through unique share code",
    unableToShareOption: "Unable to share",
    sharingWithPlaceholder: "Add email & click +",
    pdfPreviewUnavailable:
      "PDF preview is temporarily unavailable. You can still continue with the share and handover process.",
    confirmCheckboxLabel:
      "Please confirm the details are correct before proceeding",
    checkboxErrorMessage: "Please confirm the details on the PDF are correct",
    addEmail: "Add an email to proceed",
    emailSentTo: "Send to:",
    warningAddEmail: "Add email to list before proceeding",
    infoBannerMessage:
      "Email address(es) shown above have been officially provided by the place of safety",
    infoBannerMessage_136:
      "Email address(es) shown above have been officially provided by the place of safety",
    infoBannerMessage_mca:
      "Email address(es) shown above have been officially provided by the emergency department",
    successPage: {
      title: "Form Shared & Handover Initiated",
      warningBannerMessage:
        "You must stay until handover has been completed and any outstanding risks have been managed.",
      warningBannerMessage_136:
        "You must stay until handover has been completed and any outstanding risks have been managed.",
      warningBannerMessage_mca:
        "You must stay with the person until the Emergency Department staff have informed whether police presence is required or you are satisfied the person is in a safe space.",
      successMessage: "Form successfully sent to: <bold>{{ email }}</bold>",
      accessForm: "To access the form, health services must:",
      verificationLink: "1. Access the link sent to the email above",
      confirmedEmail: "2. Confirm their email address & add their name",
      guestAccessCode:
        "3. If they're guest users, enter a second 'Guest user access code' sent to the email provided in step 2.",
      awaitHealthServicesNotification:
        "Once complete, click close and wait for health services to inform ongoing police presence",
      awaitHealthServicesNotification_136:
        "Once complete, click close and wait for health services to inform ongoing police presence",
      awaitHealthServicesNotification_mca:
        "Once complete, click close and wait for form to be accessed",
      clickCloseMessage:
        "Click close and wait for health services to inform ongoing police presence",
      clickCloseMessage_136:
        "Click close and wait for health services to inform ongoing police presence",
      clickCloseMessage_mca: "Click close and wait for the form to be accessed",
      handoverInitiated:
        "Section 136 handover initiated with <bold>{{ posName }}</bold>",
      handoverInitiated_136:
        "Section 136 handover initiated with <bold>{{ posName }}</bold>",
      handoverInitiated_mca:
        "Section 1-6 (MCA) form shared with <bold>{{ posName }}</bold>",
      formSharedUrl: "Form shared via URL and share code ",
    },
    shareWithoutEmail: {
      posWithoutEmail:
        "For the POS to access any forms without using email, please ask them to follow the steps below.",
      posWithoutEmail_136:
        "For the POS to access any forms without using email, please ask them to follow the steps below.",
      posWithoutEmail_mca:
        "For the Emergency Department to access any forms without using email, please ask them to follow the steps below.",
      healthServices: "1. Health/AMHP services can go to URL:",
      healthServices_136: "1. Health/AMHP services can go to URL:",
      healthServices_mca: "1. Emergency Department staff can go to URL:",
      incidentCode: "2. Type in the incident code below",
      healthConfirmEmail:
        "3. Health/AMHP services confirm their details and email address",
      healthConfirmEmail_136:
        "3. Health/AMHP services confirm their details and email address",
      healthConfirmEmail_mca:
        "3. Emergency Department staff confirm their details and email address",
      guestUsers:
        "4. If they're guest users, enter a second Guest user access code sent to the email they provided. If there are any issues receiving emails please contact Thalamos support <1>here</1>.",
      healthServicesCheckboxLabel:
        "Health services successfully received the form",
      healthServicesCheckboxLabel_136:
        "Health services successfully received the form",
      healthServicesCheckboxLabel_mca:
        "Emergency Department staff successfully received the form",
      checkboxErrorMessage:
        "Please confirm that health services received the form",
    },
    unableToShare: {
      messageOne:
        "This option should only be selected if digital sharing is completely blocked for the incident.",
      messageTwo:
        "If you are unable to share your Section 136 digitally, end the incident and explain why.",
      messageTwo_136:
        "If you are unable to share your Section 136 digitally, end the incident and explain why.",
      messageTwo_mca:
        "If you are unable to share your form digitally, end the incident and explain why.",
      messageThree:
        "Please make sure your form is fully completed before doing so.",
      endForm: "End Form",
    },
  },
  formProgressPage: {
    update: "Update",
    stillAtPlaceOfSafety: "Still at Place of Safety?",
    stillAtPlaceOfSafety_136: "Still at Place of Safety?",
    stillAtPlaceOfSafety_mca: "Still at Emergency Department?",
    share: "Share With NHS",
    shareWithPOS: "Share with POS",
    shareWithPOS_136: "Share with POS",
    shareWithPOS_mca: "Share with ED",
    arrival: "Arrival",
    activePlaceOfSafety: {
      title: "Latest Place of Safety: ",
      title_136: "Latest Place of Safety: ",
      title_mca: "Latest Emergency Department: ",
      notKnown: "Not known",
    },
    formShared: "Form shared",
    confirmArrival:
      "Confirm arrival when you enter the doors of the place of safety",
    confirmArrival_136:
      "Confirm arrival when you enter the doors of the place of safety",
    confirmArrival_mca:
      "Confirm arrival when you enter the doors of the emergency department",
    confirmHandover:
      "Share form and initiate handover with latest place of safety",
    confirmHandover_136:
      "Share form and initiate handover with latest place of safety",
    confirmHandover_mca:
      "Share form and initiate handover with latest emergency department",
    arrivalNotConfirmed: "Add Place of Safety to confirm arrival",
    arrivalNotConfirmed_136: "Add Place of Safety to confirm arrival",
    arrivalNotConfirmed_mca: "Add Emergency Department to confirm arrival",
    completeAllSections: "Complete all sections & confirm arrival to share",
    arrivalConfirmed: "Arrival confirmed",
    endForm: "End Form",
    transfer: "Share with officer",
    cancelTransfer: "Cancel Transfer",
    add: "Add +",
    view: "View",
    statuses: {
      s136InProgress: "S136 - Form in progress",
      s136InProgress_136: "S136 - Form in progress",
      s136InProgress_mca: "MCA - Form in progress",
      awaitingArrival: "S136 - Awaiting Arrival",
      awaitingArrival_136: "S136 - Awaiting Arrival",
      awaitingArrival_mca: "MCA - Awaiting Arrival",
      arrivedAtPlaceOfSafety: "S136 - Arrived at POS",
      arrivedAtPlaceOfSafety_136: "S136 - Arrived at POS",
      arrivedAtPlaceOfSafety_mca: "MCA - Arrived at ED",
      formShared: "S136 - Form Shared",
      formShared_136: "S136 - Form Shared",
      formShared_mca: "MCA - Form Shared",
      formAccessed: "S136 - Form Accessed",
      formAccessed_136: "S136 - Form Accessed",
      formAccessed_mca: "MCA - Form Accessed",
      policePresenceRequested: "S136 - Police support requested",
      policePresenceNotRequested: "S136 - Police free to leave",
      ended: "S136 - Form Ended",
      ended_136: "S136 - Form Ended",
      ended_mca: "MCA - Form Ended",
      formAutoClosed: "Form auto-closed",
    },
  },
  onboarding: {
    welcomeTitle: "Welcome to Thalamos!",
    welcomeMessage:
      "As this is your first time logging on, you will need to provide some details about yourself before completing any forms. Please fill out the questions below.",
    name: "Name:",
    email: "Email:",
    organisationMembership: "Organisation Membership:",
    confirm: "Confirm",
    error: "Failed to save details",
  },
  triageIncident: {
    title: "Incident Triage",
    isHealthcareProfessionalConsulted:
      "Did you consult with anyone from Health/AMHP services to assist with your decision making & actions taken?",
    isHealthcareProfessionalConsultedRequired:
      "Please confirm if a healthcare professional has been consulted",

    howDidYouContactNhs: {
      title: "How did you contact the healthcare professional?",
      required: "Please confirm how you contacted the healthcare professional",
      options: {
        healthcarePractitionerAmbulance:
          "Healthcare practitioner/Ambulance on scene",
        ldPractitionersInCustody: "L&D practitioners in custody",
        custodyHealthcarePractitioner:
          "Custody Healthcare practitioner (Dr/RN/Para)",
        panLondonMentalHealthAdviceLine:
          "Pan London Mental Health Advice Line: 0300 200 0169",
        localMentalHealthAdviceLine:
          "Direct to local mental health advice line",
        localHbpos: "Direct to local HBPOS (Health-Based Place of Safety)",
        localStreetTriageTeam: "Direct to local street triage team",
        mentalHealthTeamOther: "Mental Health Team other",
        triageCarHO: "Triage car - HO",
        triageCarBtp: "Triage car - BTP",
        nhs111: "NHS 111",
        nhsStaffNwr: "NHS Staff NWR",
        nhsStaffAE: "NHS Staff A&E",
        controlRoom: "Control Room",
        amph: "AMHP",
        ///
        other: "Other",
      },
    },
    isAdviceGiven:
      "Please confirm: Healthcare professional is of the opinion that the person is likely to lack the mental capacity to make this decision as a result of a mental disorder",
    givenHealthCareProfessionalAdvice:
      "What advice did the healthcare professional give?",
    givenHealthCareProfessionalAdviceRequired:
      "Please select the option which best captures the advice by a healthcare professional",
    reasonsForDetention: "Reasons for detention",
    clinicalCaseRecordNumber:
      "Please provide the clinical case record number for this call",
    provideDetails: "Please provide details",
    connectSafeguardingReport: "Please complete a CONNECT Safeguarding report",
    s136MentalHealthInvestigationBanner:
      "Please complete a CONNECT 'Mental Health Investigation - Detention under S136 Mental Health Act' report. View the 'Policy Help' section in the navigation menu for details",
    useOfMCA2005InvestigationBanner:
      "The Mental Capacity Act should <bold>not</bold> be used to circumvent the Mental Health Act and should only be used in situations where the individual lacks capacity and the primary need is for urgent medical intervention for a physical health condition.\nPlease complete a CONNECT 'Mental Health Investigation - Use of Mental Capacity Act 2005' report.\nView the 'Policy Help' section in the navigation menu for details",
    criminalOffenceWarningBanner:
      "Please complete a CONNECT 'Vulnerable Person to Notice report'.",
    completeReport:
      "Please complete a CONNECT 'Vulnerable Person to Notice report'.",
    // Impairment, not disorder: the Mental Capacity Act turns on impairment of
    // the mind or brain, which is wider than mental disorder.
    confirmMentalCapacityLack:
      "Please confirm: Healthcare professional is of the opinion that the person is likely to lack the mental capacity to make this decision as a result of a mental impairment",
    reasonNotConsulted: {
      title: "Why was a healthcare professional not consulted?",
      required:
        "Please give reason why a healthcare professional was not consulted prior to detention",
      banner:
        "Please contact the Mental Health Clinical Advice Line on 0300 200 0169 for advice on what action to take ",
      options: {
        needForCare: "Immediate need for care (Not practicable)",
        immediateControl: "Immediate need for control (Not practicable)",
        immediateNeedForCareOrControl:
          "Immediate need for care and/or control (Not practicable)",
        noAnswer: "No answer/reply",
        didNotConsider: "Did not consider it",
        notSureWhoToContact: "Not sure who to call",
        notDeemedNecessary: "Not deemed necessary",
        other: "Other",
        violent: "Patient is violent",
        immediateRestraint:
          "Patient needs immediate restraint due to environment/incident",
        singleCrewed: "Single Crewed/Solo Patrol",
        poorConnectivity: "Poor connectivity",
        noReply: "No answer/no reply",
      },
    },
    reasonNotConsultedOther: "Please provide details",
    whatActionWillYouTake: "What action will you take?",
    whatActionWillYouTakeRequired:
      "Please confirm what course of action you will take",
    voluntaryServicesRecommended:
      "What type of voluntary support did they recommend?",
    voluntaryServicesRecommendedRequired:
      "Please confirm what voluntary services were recommended",
    voluntaryAction: {
      options: {
        voluntaryAttendanceHospital: "Voluntary attendance at hospital",
        divertOtherHealthservice: "Divert to other health service",
        contactSupportGroup: "Contact support group",
        contactFriendsFamily: "Contact friends or family",
        takePersonHome: "Take person home",
        divertCrisisCafe: "Divert to crisis café",
        other: "None of the above (please provide details)",
      },
      other: {
        title: "Please provide details",
        required: "Please confirm what other action you will take",
      },
    },
    otherAction: {
      title: "What other action will you take?",
      options: {
        arrestCriminalOffence: "Arrest for criminal offence",
        watchList: "Put on watch list",
        referSupportOptions: "Refer to other support options",
        other: "Other (please specify)",
      },
    },
    whatWillYouDo: {
      136: "Detain under 136",
      56: "Detain under 5-6",
      voluntary: "Voluntary Support",
      other: "Other",
      mentalCapacityAct: "Mental Capacity Act",
      alternativePathway: "Alternative Pathway",
      arrestForCriminalOffence: "Arrest for criminal offence",
    },
    whatWillYouDoOther: "Please provide details",
    otherActionDetails: "Add more details",
    otherActionBanner:
      "This platform should only be used for incidents where a person's mental health is a risk to themselves or others. If none of these options apply, please reach out to your supervisor to confirm most appropriate next steps.",
    explainWhyActionDiffers: {
      title:
        "Your action differs from the advice given by health/AMHP services. Please explain why",
      options: {
        changeInPresentation: "Change in presentation",
        differenceInOpinion: "Difference in opinion and/or assessment of risk",
        other: "Other",
      },
    },
    explainWhyActionDiffersOther: "Please provide details",
    unsupportedAction:
      "Section 1-6 (Mental Capacity Act) and Voluntary mental health forms are not yet available on this platform. Please continue to follow existing procedures for such incidents or contact your supervisor for more information.",
    voluntaryNotDigitalisedBanner:
      "This form is not currently digitalised yet. Please complete a paper form instead.",
    mentalCapacityActCautionBanner:
      "The Mental Capacity Act should not be used to circumvent the Mental Health Act and should only be used in situations where the individual lacks capacity and the primary need is physical healthcare.",
  },
  shareIncident: {
    title: "Share Incident",
  },
  recordPlaceOfSafety: {
    title: "Record Place of Safety",
    title_136: "Record Place of Safety",
    title_mca: "Record Emergency Department",
    choosePlaceOfSafety: {
      title: "Choose a Place of Safety",
      title_136: "Choose a Place of Safety",
      title_mca: "Choose an Emergency Department",
      confirmCorrect: "Please confirm these details are correct",
    },
    choosePlaceOfSafetyType: {
      publicPlaceLocationDescriptionBanner:
        "Please ensure the relevant person(s) understand the intended use of the space and the safety arrangements for all present. Make it clear they are not legally obligated to agree. This request and their consent should be documented separately from this form.",
      warningBanner:
        "A police station cannot be used as a place of safety for anyone under 18. Extending Section 136 powers in a police station requires approval from a Superintendent or above.",
      title: "What type of Place of Safety is this?",
      title_136: "What type of Place of Safety is this?",
      title_mca: "What type of Emergency Department is this?",
      required: "Please describe what type of Place of Safety this is",
      required_136: "Please describe what type of Place of Safety this is",
      required_mca: "Please describe what type of Emergency Department this is",
      whoAuthorisedCustodySuite:
        "Who authorised the use of custody suite as a POS? (Inspector or above)",
      whoAuthorisedCustodySuite_136:
        "Who authorised the use of custody suite as a POS? (Inspector or above)",
      whoAuthorisedCustodySuite_mca:
        "Who authorised the use of custody suite as an ED? (Inspector or above)",
      options: {
        hbPos136: "HBPOS (136 Suite)",
        emergencyDepartment: "Emergency Department (A&E)",
        policeStation: "Police Station (exceptional circumstances)",
        returnedToMentalHealthUnit: "Returned to Mental Health Unit",
        careHome: "Care Home",
        custody: "Custody (exceptional circumstances)",
        privateHome: "Private home",
        other: "Other (please specify)",
      },
    },
    whyTakingPersonToEmergencyDepartment: {
      title: "Why are you taking this person to an Emergency Department (A&E)?",
      required: "Please indicate why you took this person to an ED (A&E)",
      options: {
        noHealthBasedPlaceOfSafetyAvailable:
          "No Health Based Place of Safety (HBPOS) is available",
        unreasonableDelayFindingHbpos:
          "Unreasonable delay in finding a HBPOS so a police decision was made to take to Emergency Department (A&E)",
        medicalAttentionNeeded: "Medical attention needed",
        policeStationUsed: "Police station used - regulations met",
        otherPleaseAddDetails: "Other (please add details)",
      },
    },
    otherEmergencyDepartmentReasonDetails:
      "Please explain where you are taking this person and why",
    otherEmergencyDepartmentReasonDetailsRequired:
      "Please provide further details on why you took them to an ED (A&E)",
    choosePlaceOfSafetyTypeOther: {
      title: "Please specify",
    },
    whyNotHbPosReason: {
      title: "Why are you not taking this person to a S136 Suite?",
      options: {
        noS136SuitesAvailable: "No available S136 suites",
        emergencyMedicalNeed: "Injury/Medical and require A&E",
        substanceRelatedEmergency: "Alcohol/drugs and require A&E",
        secureCustodyRequired: "Secure custody environment required",
        other: "Other (please add details)",
      },
    },
    whyNotHbPosReasonOther: {
      title: "Please specify",
    },
  },
  arrivePlaceOfSafety: {
    identityBanner: 'Place of Safety is "{{placeOfSafetyName}}"',
    identityBanner_136: 'Place of Safety is "{{placeOfSafetyName}}"',
    identityBanner_mca: 'Emergency Department is "{{placeOfSafetyName}}"',
    title: "Arrive at Place of Safety",
    title_136: "Arrive at Place of Safety",
    title_mca: "Arrive at Emergency Department",
    arrivalDate: "What date did you arrive?",
    arrivalTime: "What time did you arrive?",
    arrivalDateTimeRequired:
      "Please confirm when you arrived at this Place of Safety",
    arrivalDateTimeRequired_136:
      "Please confirm when you arrived at this Place of Safety",
    arrivalDateTimeRequired_mca:
      "Please confirm when you arrived at this Emergency Department",
    didNotArrive: "No arrival at Place of Safety",
    didNotArrive_136: "No arrival at Place of Safety",
    didNotArrive_mca: "No arrival at Emergency Department",
    advisePhysicallyEnter: "Arrival is when you enter the facility",
    advisePhysicallyEnter_136: "Arrival is when you enter the facility",
    advisePhysicallyEnter_mca: "Arrival is when you enter the facility",
    adviseCannotShare:
      "You won't be able to share until you physically entered the place of safety.",
    adviseCannotShare_136:
      "You won't be able to share until you physically entered the place of safety.",
    adviseCannotShare_mca:
      "You won't be able to share until you physically entered the emergency department.",
    wasEntryDelayed: "Was your entry to the Place of Safety delayed?",
    wasEntryDelayed_136: "Was your entry to the Place of Safety delayed?",
    wasEntryDelayed_mca: "Was your entry to the Emergency Department delayed?",
    wasEntryDelayedRequired:
      "Please confirm if your immediate entry into the building was delayed for any reason",
    whyWasEntryDelayed: {
      title: "What caused any delays?",
      required:
        "Please provide some additional information around the reason you were delayed entering the POS",
      required_136:
        "Please provide some additional information around the reason you were delayed entering the POS",
      required_mca:
        "Please provide some additional information around the reason you were delayed entering the ED",
      options: {
        posOrEdClosed: "POS/ED is closed",
        nhsAdvisedWaitOutside: "NHS decision made for officers to wait outside",
        other: "Other",
      },
    },
    whyWasEntryDelayedOther: {
      title: "Please provide details",
      required:
        "Please provide more details on why you were delayed from immediately entering the POS",
      required_136:
        "Please provide more details on why you were delayed from immediately entering the POS",
      required_mca:
        "Please provide more details on why you were delayed from immediately entering the ED",
    },
    howLongWasEntryDelayed: {
      title: "How long were you delayed?",
      required:
        "Please confirm how long you were waiting outside the POS before you could enter",
      required_136:
        "Please confirm how long you were waiting outside the POS before you could enter",
      required_mca:
        "Please confirm how long you were waiting outside the ED before you could enter",
      options: {
        "0-15": "0 - 15 mins",
        "15-30": "15 - 30 mins",
        "30-60": "30 mins - 1 hour",
        "60+": "Over 1 hour",
        "60-120": "1 - 2 hours",
        "120+": "Over 2 hours",
      },
    },
    methodOfTransport: {
      title: "Method of transport to Place of Safety",
      title_136: "Method of transport to Place of Safety",
      title_mca: "Method of transport to Emergency Department",
      required: "Please specify a method of transport",
      options: {
        alreadyAtPos: "Already at the Place of Safety",
        alreadyAtPos_136: "Already at the Place of Safety",
        alreadyAtPos_mca: "Already at the Emergency Department",
        ambulance: "Ambulance",
        policeVehicle: "Police vehicle",
        otherHealthVehicle: "Other Health Vehicle",
        escorted: "Escorted (walked)",
        mentalHealthAmbulance: "Mental Health Ambulance",
        none: "None (already at the Place of Safety)",
        none_136: "None (already at the Place of Safety)",
        none_mca: "None (already at the Emergency Department)",
        other: "Other (please specify)",
      },
    },
    methodOfTransportOther: {
      title: "Please specify",
    },
    whyMethodOfTransportPoliceVehicle: {
      title: "Provide reasoning for using police vehicle to transport person",
      required:
        "Please provide reasoning for the use of a police vehicle to transport the person",
      options: {
        ambulanceAvailableInTimeframe:
          "Ambulance not available within agreed timeframe",
        ambulanceCrewRefused: "Ambulance crew refused to convey",
        riskAssessment:
          "Police or police/ambulance risk assessment (behaviour)",
        ambulanceNotRequested: "Ambulance not requested",
        ambulanceRetasked: "Ambulance retasked to a higher priority call",
        other: "Other (please specify)",
      },
    },
    whyMethodOfTransportPoliceVehicleOther: {
      title: "Please specify",
      required:
        "Please provide additional details on why a police vehicle, outside of the options listed",
    },
  },
  leavePlaceOfSafety: {
    banner: "The current Place of Safety is {{placeOfSafetyName}}",
    title: "Leave Place of Safety",
    title_136: "Leave Place of Safety",
    title_mca: "Leave Emergency Department",
    didYouLeave: "Have you left this Place of Safety?",
    didYouLeave_136: "Have you left this Place of Safety?",
    didYouLeave_mca: "Have you left this Emergency Department?",
    didYouLeaveRequired: "$t(common.required)",
    didYouLeaveRequired_136: "$t(common.required)",
    didYouLeaveRequired_mca: "$t(common.required)",
    leaveReason: {
      title: "Why did you leave?",
      required: "$t(common.required)",
      required_136: "$t(common.required)",
      required_mca: "$t(common.required)",
      options: {
        moreAppropriatePosAvailable: "A more appropriate POS became available",
        moreAppropriatePosAvailable_136:
          "A more appropriate POS became available",
        moreAppropriatePosAvailable_mca:
          "A more appropriate ED became available",
        unreasonableDelay: "Unreasonable delay in accessing POS",
        unreasonableDelay_136: "Unreasonable delay in accessing POS",
        unreasonableDelay_mca: "Unreasonable delay in accessing ED",
        visitAccidentAndEmergencyOnMedicalGrounds:
          "Medical attention needed (attending A&E)",
        physicalHealthCheckComplete: "Health check complete",
        other: "Other (please specify)",
      },
    },
    leaveReasonOther: {
      title: "Please specify",
    },
    leaveAuthorisedBy: {
      title: "Who authorised the transfer between Places of Safety?",
      title_136: "Who authorised the transfer between Places of Safety?",
      title_mca: "Who authorised the transfer between Emergency Departments?",
      required: "$t(common.required)",
      required_136: "$t(common.required)",
      required_mca: "$t(common.required)",
      options: {
        constable: "A constable",
        mentalHealthProfessional: "An approved mental health professional",
        constableDelegate: "A person authorised by a constable",
        mentalHealthProfessionalDelegate:
          "A person authorised by an approved mental health professional",
        noAgreement: "No agreement due to emergency",
        other: "Other (please specify)",
      },
    },
    leaveAuthorisedByOther: {
      title: "Please specify",
    },
  },
  reviewPlacesOfSafety: {
    title: "Review Places of Safety",
    title_136: "Review Places of Safety",
    title_mca: "Review Emergency Departments",
    placesOfSafety: "Places of Safety",
    placesOfSafety_136: "Places of Safety",
    placesOfSafety_mca: "Emergency Departments",
    latestPlaceOfSafety: "Latest Place of Safety",
    latestPlaceOfSafety_136: "Latest Place of Safety",
    latestPlaceOfSafety_mca: "Latest Emergency Department",
    otherPlacesOfSafety: "Other Places of Safety",
    otherPlacesOfSafety_136: "Other Places of Safety",
    otherPlacesOfSafety_mca: "Other Emergency Departments",
    edit: "Edit",
    noOtherPlacesOfSafety: "None",
    noOtherPlacesOfSafety_136: "None",
    noOtherPlacesOfSafety_mca: "None",
    arrivalNone: "No arrival",
    arrivalNone_136: "No arrival",
    arrivalNone_mca: "No arrival",
    arrivalDate: "Arrived at {{date}}",
    arrivalDate_136: "Arrived at {{date}}",
    arrivalDate_mca: "Arrived at {{date}}",
    didYouVisitMore:
      "Did you visit any other Places of Safety for this incident?",
    didYouVisitMore_136:
      "Did you visit any other Places of Safety for this incident?",
    didYouVisitMore_mca:
      "Did you visit any other Emergency Departments for this incident?",
    add: "Add",
    next: "Next",
  },
  singlePageForm: {
    cancel: "Close",
    confirm: "Confirm",
  },
  userProfile: {
    title: "Profile",
    banner:
      "Please enter your professional information and click save. Your profile details will be populated onto the forms you are completing.",
    confirm: "Save",
    name: "Name",
    email: "Email",
    organisationMembership: "Organisation Membership",
    role: "Role",
    shoulderNumber: "Shoulder Number",
    success: "Profile successfully saved",
    error: "Failed to save profile",
  },
  formSuccess: {
    proceed: "Proceed",
    formComplete: "Form section complete",
    proceedWith: "Proceed with:",
    section136Form: "Section 136 form",
    mcaForm: "MCA form",
    voluntaryForm: "Voluntary form",
    otherForm: "Other form",
    mentalHealthFormTitle: "Mental Health Incident form",
    mentalHealthForm: "Mental health incident form created by officer ",
    incidentTriage: "Incident Triage",
    triageComplete: "Incident Triage completed.",
    personDetails: "Person details",
    personDetailsComplete: "Person Detail section has been completed",
    detentionDetails: "Detention details",
    detentionDetailsComplete: "Detention Detail section has been completed",
    informationForHealthcare: "Information for healthcare",
    informationForHealthcareStaff: "Information for healthcare staff",
    informationForHealthcareComplete:
      "Information for healthcare section has been completed",
    mcaPersonDetails: "Person details",
    mcaPersonDetailsComplete: "Person Detail section has been completed",
    mcaIncidentDetails: "Incident details",
    mcaIncidentDetailsComplete: "Incidents Detail section has been completed",
    mcaCapacityAssessment: "Mental Capacity Assessment",
    mcaCapacityAssessmentComplete:
      "Mental Capacity Assessment section has been completed",
    mcaAccompaniment: "Accompaniment",
    mcaAccompanimentComplete: "Accompaniment section has been completed",
    incidentProgress: "Incident progress",
    sharePOS: "Share place of Safety",
    sharePOS_136: "Share place of Safety",
    sharePOS_mca: "Share Emergency Department",
    addPOS: "Add place of safety",
    addPOS_136: "Add place of safety",
    addPOS_mca: "Add emergency department",
    arrivePOS: "Arrive at place of safety",
    arrivePOS_136: "Arrive at place of safety",
    arrivePOS_mca: "Arrive at emergency department",
    leavePOS: "Leave place of safety",
    leavePOS_136: "Leave place of safety",
    leavePOS_mca: "Leave emergency department",
    confirmed: "Confirmed",
    proceedToShare:
      "Proceed to share details with Place of Safety and initiate handover",
    proceedToShare_136:
      "Proceed to share details with Place of Safety and initiate handover",
    proceedToShare_mca:
      "Proceed to share details with Emergency Department and initiate handover",
    currentPos: "Current place of safety",
    currentPos_136: "Current place of safety",
    currentPos_mca: "Current emergency department",
    arrivedAt: "Arrived at",
    endForm: "End Form",
    formEnded: "Section 136 has been ended.",
    formEnded136: "Section 136 has been ended.",
    formEndedMca: "MCA has been ended.",
    formEndedVoluntary: "Voluntary form has been ended.",
    formEndedOther: "Form has been ended.",
    formEndedReason: "Reason recorded:",
    formEndedArchived:
      "This form will be available in your archive for 3 months.",
    policePresence: "Record Police Presence",
    policePresenceComplete: "Police Presence has been recorded",
    downloadPdf: "Download PDF",
    failedToDownloadPdf: "Failed to download PDF",
  },
  personDetails: {
    title: "Person Details",
    personAddress: "Person's home address",
    personAddressRequired: "Please confirm person's home address",
    confirmPersonAddress:
      "Please confirm you have entered the address correctly",
    confirmPersonAddressRequired:
      "Please confirm you have entered the address correctly by checking the box",
    localAuthorityAddress: "Local authority of person's home address",
    relativeOrFriendAddress: "Address of relative or friend",
    relativeOrFriendAddressRequired:
      "Please confirm home address of relative or friend",
    relativeOrFriendTelephone: "Telephone number of relative or friend",
    relativeOrFriendTelephoneRequired:
      "Please provide a valid telephone number",
    relativeOrFriendInformed:
      "Has the relative or friend been informed of the detention?",
    relativeOrFriendInformedRequired:
      "Please confirm if relative or friend has been informed of detention",
    reasonNotInformed:
      "Please explain why the relative or friend has not been informed",
    reasonNotInformedRequired:
      "Please explain why the relative or friend has not been informed",
    gender: {
      title: "Gender Identity",
      required: "Please confirm the gender identity of the person",
      options: {
        male: "Male",
        female: "Female",
        nonBinary: "Non-binary",
        preferNotToSay: "Prefer not to say",
        other: "Other",
      },
    },
    ethnicity: {
      title: "Ethnic Appearance",
      required: "Please confirm what the persons Ethnic Appearance is",
      options: {
        IC1: "IC1 - White, Northern European",
        IC2: "IC2 - South European",
        IC3: "IC3 - African/Afro-Caribbean",
        IC4: "IC4 - Indian, Pakistani, Nepalese, Maldivian, Sri Lankan, Bangladeshi, or any other (South) Asian",
        IC5: "IC5 - Chinese, Japanese, or South-East Asian",
        IC6: "IC6 - Middle Eastern/Arab",
        IC7: "IC7 - Origin UNKNOWN",
      },
    },
    selfDeclaredEthnicity: {
      title: "Self Declared Ethnicity",
      required:
        "Please confirm what the person describes their ethnicity as from the list provided",
      options: {
        whiteEnglish:
          "White - English / Welsh / Scottish / Northern Irish / British",
        whiteIrish: "White - Irish",
        whiteGypsy: "White - Gypsy or Irish Traveller",
        whiteRoma: "White - Roma",
        whiteOther: "Any other White background, please describe",
        mixedBlackCaribbean:
          "Mixed / Multiple ethnic groups - White and Black Caribbean",
        mixedBlackAfrican:
          "Mixed / Multiple ethnic groups - White and Black African",
        mixedAsian: "Mixed / Multiple ethnic groups - White and Asian",
        mixedOther:
          "Any other Mixed / Multiple ethnic background, please describe",
        asianEnglish:
          "Asian / Asian British - English / Welsh / Scottish / Northern Irish / British",
        asianIndian: "Asian / Asian British - Indian",
        asianPakistani: "Asian / Asian British - Pakistani",
        asianBangladeshi: "Asian / Asian British - Bangladeshi",
        asianChinese: "Asian / Asian British - Chinese",
        asianOther: "Any other Asian background, please describe",
        blackEnglish:
          "Black / African / Caribbean / Black British - English / Welsh / Scottish / Northern Irish / British",
        blackAfrican: "Black / African / Caribbean / Black British - African",
        blackCaribbean:
          "Black / African / Caribbean / Black British - Caribbean",
        blackOther:
          "Black / African / Caribbean / Black British - Any other Black / African / Caribbean background, please describe",
        arab: "Other ethnic group - Arab",
        other: "Any other ethnic group, please specify",
        preferNotToSay: "Prefer not to say",
        unableToAnswer: "Unable to answer",
      },
    },
    selfDeclaredEthnicityOther: "Please specify",
    dob: "Person's date of birth",
    dobRequired: "Please confirm date of birth",
    satisfiedPersonIsOver18:
      "Are you satisfied the person is over the age of 18?",
    satisfiedPersonIsOver18Required:
      "Please confirm if you are satisfied that the person is over the age of 18",
    satisfiedPersonIsOver16:
      "Are you satisfied the person is over the age of 16?",
    satisfiedPersonIsOver16Required:
      "Please confirm if you are satisfied that the person is over the age of 16",
    mcaLegalAgeBanner:
      "The Mental Capacity Act is designed to provide a legal basis for providing care and treatment for people aged 16 and over who lack the mental capacity to give their consent",
    nationalComputerCheck:
      "Have you carried out a Police National Computer check?",
    pncRecordForPerson:
      "Is there a Police National Computer record for this person?",
    pncidNumber: "PNCID no.",
    pncWarningMarkers: {
      title: "What are the PNC Warning markers?",
      options: {
        alleges: "AG - Alleges",
        ailment: "AT - Ailment",
        conceals: "CL - Conceals",
        contagious: "CO - Contagious",
        drugs: "DR - Drugs",
        escaper: "ES - Escaper",
        firearm: "FI - Firearm",
        fImpers: "IF - F/Impers",
        mImpers: "IM - M/Impers",
        impersonates: "IS - Impersonates",
        mentalHealth: "MN - Mental Health",
        selfHarm: "SH - Self Harm",
        suicidal: "SU - Suicidal",
        violent: "VI - Violent",
        weapons: "WE - Weapons",
        explosives: "XP - Explosives",
      },
    },
    relativeOrFriend: "Do you have the details of a relative or friend?",
    relativeOrFriendRequired:
      "Please confirm if you have the details of a relative or friend",
    relativeOrFriendForename: "Relative or friend forename(s)",
    relativeOrFriendForenameRequired:
      "Please confirm relative or friend forename(s)",
    relativeOrFriendSurname: "Relative or friend surname",
    relativeOrFriendSurnameRequired:
      "Please confirm relative or friend surname",
    relativeOrFriendRelationship: "Relationship to person being detained",
    relativeOrFriendRelationshipRequired:
      "Please confirm relationship to person being detained",
    relativeOrFriendSameAddress:
      "Is the home address of the relative or friend the same as the person being detained?",
    relativeOrFriendSameAddressRequired:
      "Please confirm if the relative/friend and person being detained have the same home address",
    unknownRelativeOrFriend:
      "Details of a relative or friend will be recorded as 'unknown'",
    unknownRelativeOrFriendAddress:
      "Home address of a relative or friend will be recorded as 'unknown'",
  },
  detentionDetails: {
    title: "Detention Details",
    custodyNumber: "Custody Number",
    custodyNumber_136: "Custody Number",
    custodyNumber_mca: "Custody Number",
    dateOfDetention: "Date of Section 136 detention",
    timeOfDetention: "Time of Section 136 detention",
    dateTimeOfDetentionRequired: "Please enter the date and time of detention",
    custodyNumberRequired: "Please enter the custody number",
    userIsAttendingOfficer: "Were you the detaining officer?",
    incidentAndLocationSameLocation:
      "Did the original police incident and Section 136 detention occur in the same location?",
    originalPoliceIncidentSameLocationRequired:
      "Please confirm if the original police incident and Section 136 detention occurred in the same location",
    userIsAttendingOfficerRequired:
      "Please confirm if you were the officer who detained the person",
    orgResponsibleForDetention: "In which BCU did the detention take place?",
    orgResponsibleForDetentionRequired:
      "Please confirm in which BCU the detention occurred",
    commandUnit: "In which BCU did the incident take place?",
    commandUnitRequired: "Please confirm in which BCU the incident took place",
    createdOnBehalfOfAnotherOfficerWithShoulderNumber:
      "Please confirm the $t(common.shoulderNumber) of the detaining officer",
    createdOnBehalfOfAnotherOfficerRequired:
      "Please add the $t(common.shoulderNumber) of the officer who detained the person",
    createdOnBehalfOfAnotherOfficerBanner:
      "Please note, the detaining officer will not have access to this form unless you transfer the form to them. You can transfer the form to them on the Incident Overview Page.",
    responsibleForDetention:
      "$t(incidentWorkItem.commandUnit) responsible for detention",
    londonBoroughTookPlace: {
      detention: {
        title: "In which London Borough did the detention take place?",
        required:
          "Please confirm in which London borough the person was detained under Section 136",
      },
      incident: {
        title: "In which London Borough did the incident take place?",
        required:
          "Please confirm in which London borough the incident took place",
      },
      options: {
        cityOfLondon: "City of London",
        barkingAndDagenham: "Barking and Dagenham",
        barnet: "Barnet",
        bexley: "Bexley",
        brent: "Brent",
        bromley: "Bromley",
        camden: "Camden",
        cityOfWestminster: "City of Westminster",
        croydon: "Croydon",
        ealing: "Ealing",
        enfield: "Enfield",
        greenwich: "Greenwich",
        hackney: "Hackney",
        hammersmithAndFulham: "Hammersmith and Fulham",
        haringey: "Haringey",
        harrow: "Harrow",
        havering: "Havering",
        hillingdon: "Hillingdon",
        hounslow: "Hounslow",
        islington: "Islington",
        kensingtonAndChelsea: "Kensington and Chelsea",
        kingstonUponThames: "Kingston upon Thames",
        lambeth: "Lambeth",
        lewisham: "Lewisham",
        merton: "Merton",
        newham: "Newham",
        redbridge: "Redbridge",
        richmondUponThames: "Richmond upon Thames",
        southwark: "Southwark",
        sutton: "Sutton",
        towerHamlets: "Tower Hamlets",
        walthamForest: "Waltham Forest",
        wandsworth: "Wandsworth",
      },
    },
    locationDetentionTookPlace: "Location where detention took place",
    locationDetentionTookPlaceRequired:
      "Please enter the nearest address to where you detained the individual",
    incidentLocation: "Location where incident took place",
    incidentLocationRequired:
      "Please enter the location where the incident took place",
    wasLifesavingInterventionDetails:
      "Please confirm in line with Ovenstone Criteria, including direct or indirect evidence of suicidal intent",
    intervention: "Who made the Intervention?",
    locationType: {
      title: "What type of location was this",
      required: "Please confirm what type of location this is",
      policeStationsCustody: "Police stations/Custody",
      onTrain: "On train",
      concourse: "Concourse / booking office",
      platform: "Platform",
      stationToilet: "Station toilet",
      stationForecourt: "Station forecourt",
      carPark: "Car park",
      onTracksAtStation: "On tracks - at station",
      onTracksAwayFromStation: "On tracks - away from station",
      lineside: "Lineside",
      bridge: "Bridge",
      levelCrossing: "Level crossing / foot crossing",
      disusedRailwayOrStation: "Disused railway or station",
      tunnel: "Tunnel",
      depot: "Depot",
      otherRailwayInfrastructure: "Other railway infrastructure",
      offBtpJurisdiction: "Off BTP jurisdiction",
      btpOffice: "BTP office",
      ticketBarriers: "Ticket barriers",
      hotelWithinRailwayEnvironment: "Hotel (within railway environment)",
      publicHouse: "Public House",
      railwayLines: "Railway lines",
      hospitalWards: "Hospital wards",
      rooftopsCommercial: "Rooftops (of commercial or business buildings)",
      policeStations: "Police stations",
      offices: "Offices",
      school: "School",
      placeOfHeight: "Place of height",
      gardensCarParks:
        "Gardens and car parks associated with communal residential property",
      nonResidentialRestricted:
        "Non-residential parts of residential buildings with restricted entry",
      street: "Street",
      park: "Park",
      other: "Other",
      emergencyDepartment: "Emergency Department",
      hospitalWardsPhysical: "Hospital Ward - Physical health",
      inpatientWard: "Inpatient Ward",
      bridgeOverWater: "Bridge over water",
      bridgeOverRoad: "Bridge over road",
      hotel: "Hotel",
      noneOfTheAbove: "None of the above",
    },
    custodyNumberDescriptionBanner:
      "If applicable, enter the custody number associated with this incident. Format is two digit Force Code with two letter detention suite, up to 7 digit serial number (leading zeros are omitted) followed by two digit year element (eg. 01AA/1111/21)",
    hotelOutOfBoundsWarningBanner:
      "A hotel room where someone is living (i.e. they have no other place of residence at that time), is out of bounds for Section 136.",

    confirmCustodySuite: {
      title: "Please confirm Custody Suite used",
      required:
        "Please confirm which custody suite was used for this detention",
      options: {
        bishopsgate: "Bishopsgate",
        holborn: "Holborn",
        islington: "Islington",
        cxFirstFloor: "CX 1st floor",
        stokeNewington: "Stoke Newington",
        woodGreen: "Wood Green",
        bethnalGreen: "Bethnal Green",
        barkingAndDagenhamFreshwharf: "Barking & Dagenham (Freshwharf)",
        romford: "Romford",
        forestGate: "Forest Gate",
        leyton: "Leyton",
        colindale: "Colindale",
        wembley: "Wembley",
        heathrow: "Heathrow",
        croydon: "Croydon",
        brixton: "Brixton",
        wandsworth: "Wandsworth",
        lewishamPfi: "Lewisham (PFI)",
        bexleyheath: "Bexleyheath",
        bromleyPfi: "Bromley (PFI)",
        walworth: "Walworth",
        acton: "Acton",
        hammersmith: "Hammersmith",
        kingston: "Kingston",
        edmonton: "Edmonton",
        kentishTown: "Kentish Town",
        cxGroundFloor: "CX Ground floor",
        ilford: "Ilford",
        harrow: "Harrow",
        suttonPfi: "Sutton (PFI)",
        plumstead: "Plumstead",
        peckham: "Peckham",
        hounslow: "Hounslow",
      },
    },
    wasLifesavingIntervention: "Was this a lifesaving intervention (LS)?",
  },
  informationForHealthcare: {
    title: "Information for Healthcare",
    incidentDescription:
      "Please give an account of the behaviour or crisis that led to Section 136 (MHA) powers being used",
    incidentDescriptionPlaceholder:
      "Grounds for S136 powers include: suffering from a mental disorder; an immediate need for care or control; and acting in the interests of the person or for the protection of others.",
    incidentDescriptionRequired:
      "Please give an account of the behaviour or crisis that led to Section 136 detention",
    wasHealthcareProvided:
      "Was physical health care provided prior to arrival at the Place of Safety (ED or HBPOS)?",
    wasHealthcareProvided_136:
      "Was physical health care provided prior to arrival at the Place of Safety (ED or HBPOS)?",
    wasHealthcareProvided_mca:
      "Was physical health care provided prior to arrival at the Emergency Department?",
    wasHealthcareProvidedRequired:
      "Please confirm if physical health care provided prior to arrival at the Place of Safety (ED or HBPOS)?",
    wasHealthcareProvidedRequired_136:
      "Please confirm if physical health care provided prior to arrival at the Place of Safety (ED or HBPOS)?",
    wasHealthcareProvidedRequired_mca:
      "Please confirm if physical health care provided prior to arrival at the Emergency Department?",
    healthcareBanner:
      "Treatment may not be administered under the Mental Health Act. Any treatment for mental or physical ill health must have another authority, for example, the capacitous consent of the patient, or a best interests decision under the Mental Capacity Act for someone lacking treatment capacity.",
    medicalAttentionProvided: "Please describe the medical attention provided",
    medicalAttentionProvidedRequired:
      "Please describe the medical attention provided",
    wasForceUsed: "Was force used during detention?",
    wasForceUsedRequired: "Please confirm if force was used",
    useOfForceReminder:
      "Remember to complete a Use of Force Form along with this submission if force was used",
    useOfForceType: {
      title: "What type of force was used? Select all that apply",
      required: "Please select at least one type of force used",
      options: {
        handcuffing: "Handcuffing (compliant and non-compliant)",
        unarmedSkills:
          "Unarmed skills (including pressure points, strikes, restraints and take-downs)",
        dogs: "Use of dogs",
        baton: "Drawing or use of baton",
        irritantSpray: "Drawing or use of irritant spray",
        limbBodyRestraints: "Limb/body restraints",
        spitGuard: "Spit guard",
        shield: "Shield",
        ced: "Conductive Energy Device (CED - Taser) in any of the seven categories of use",
        aep: "AEP: drawn or discharged",
        firearms: "Firearms: drawn or discharged",
        otherImprovised: "Other/improvised",
        handcuffingCompliant: "Handcuffing (compliant)",
        handcuffingNonCompliant: "Handcuffing (non-compliant)",
        tacticalCommunication: "Tactical communication",
        dogBite: "Dog bite",
        groundRestraint: "Ground restraint",
      },
    },
    useOfForceContext: {
      options: {
        immediatelyOnScene: "Immediately when arrived on scene",
        enrouteToPlaceOfSafety: "Enroute to Place of Safety",
        intermittentlyAtPlaceOfSafety:
          "Intermittently whilst at Place of Safety",
        consistentlyAtPlaceOfSafety: "Consistently whilst at Place of Safety",
        detentionUntilHandover: "From time of detention until handover",
        other: "Other (please specify)",
      },
    },
    useOfForceContextHandcuffing: {
      title:
        "In what context did you use handcuffing (compliant and non-compliant)?",
      required: "Please select the context in which handcuffing was used",
    },
    useOfForceContextUnarmedSkills: {
      title:
        "In what context did you use unarmed skills (including pressure points, strikes, restraints and take-downs)?",
      required: "Please select the context in which unarmed skills were used",
    },
    useOfForceContextDogs: {
      title: "In what context did you use dogs?",
      required: "Please select the context in which dogs were used",
    },
    useOfForceContextBaton: {
      title: "In what context did you draw or use a baton?",
      required: "Please select the context in which a baton was drawn or used",
    },
    useOfForceContextIrritantSpray: {
      title: "In what context did you draw or use irritant spray?",
      required:
        "Please select the context in which irritant spray was drawn or used",
    },
    useOfForceContextLimbBodyRestraints: {
      title: "In what context did you use limb/body restraints?",
      required:
        "Please select the context in which limb/body restraints were used",
    },
    useOfForceContextSpitGuard: {
      title: "In what context did you use a spit guard?",
      required: "Please select the context in which a spit guard was used",
    },
    useOfForceContextShield: {
      title: "In what context did you use a shield?",
      required: "Please select the context in which a shield was used",
    },
    useOfForceContextCed: {
      title:
        "In what context did you use a Conductive Energy Device (CED - Taser)?",
      required:
        "Please select the context in which a Conductive Energy Device (CED - Taser) was used",
    },
    useOfForceContextAep: {
      title: "In what context did you draw or discharge an AEP?",
      required:
        "Please select the context in which an AEP was drawn or discharged",
    },
    useOfForceContextFirearms: {
      title: "In what context did you draw or discharge firearms?",
      required:
        "Please select the context in which firearms were drawn or discharged",
    },
    useOfForceContextOtherImprovised: {
      title: "In what context did you use other/improvised force?",
      required:
        "Please select the context in which other/improvised force was used",
    },
    useOfForceContextHandcuffingCompliant: {
      title: "In what context did you use compliant handcuffing?",
      required:
        "Please select the context in which compliant handcuffing was used",
    },
    useOfForceContextHandcuffingNonCompliant: {
      title: "In what context did you use non-compliant handcuffing?",
      required:
        "Please select the context in which non-compliant handcuffing was used",
    },
    useOfForceContextTacticalCommunication: {
      title: "In what context did you use tactical communication?",
      required:
        "Please select the context in which tactical communication was used",
    },
    useOfForceContextDogBite: {
      title: "In what context did the dog bite happen?",
      required: "Please select the context in which the dog bite happened",
    },
    useOfForceContextGroundRestraint: {
      title: "In what context did you use ground restraint?",
      required: "Please select the context in which ground restraint was used",
    },
    useOfForceContextOther: "Please specify the context",
    useOfForceContextOtherRequired:
      "Please provide details of the other context",
    describeForceUsed: "Please describe the force used, and for how long",
    describeForceUsedRequired:
      "Please describe the force used including how long it was used for",
    hasPersonBeenSearched: "Has the person been searched?",
    hasPersonBeenSearchedRequired:
      "Please confirm if the person has been searched",
    didSeizeProperty: "Did you seize any property?",
    didSeizePropertyRequired: "Please confirm if you seized any property",
    detailsPropertySeized: "Please provide details of the property seized",
    detailsPropertySeizedRequired:
      "Please provide detail of the property seized",
    clothingRemovalWarning:
      "Section 136 does not authorise removal of clothing, other than an outer coat, jacket or gloves.",
    underInfluenceOfSubstance:
      "Is the person under the influence of alcohol or drugs?",
    underInfluenceOfSubstanceRequired:
      "Please confirm if the person was under the influence of drugs or alcohol",
    substanceInfluenceBanner:
      "If the individual has consumed alcohol and/or drugs to the point of being unable to either walk unaided or stand unaided or is unaware of their own actions or unable to fully understand what is said to them, this should be treated as a medical emergency and the person should be taken to an ED. ",
    hasAdditionalRiskFactors:
      "Are there any additional risk factors that should be shared with healthcare staff?",
    hasAdditionalRiskFactorsRequired:
      "Please confirm if any risk factors are known that are relevant for healthcare staff?",
    describeRiskFactors: {
      title: "Please describe risk factors",
      required:
        "Please select known risk factors applicable to this individual",
      options: {
        substanceAbuse: "Alcohol / drug / substance misuse / abuse",
        bereavement: "Bereavement (inc. Suicide)",
        bullying: "Bullying (inc. Cyber)",
        carerIssues: "Carer responsibilities / issues",
        clininicallyDiagnosedNeurodiverse:
          "Clinically diagnosed neurodiverse condition (inc. Aspergers)",
        clininicallyDiagnosedMentalHealthIllness:
          "Clinically diagnosed mental health illness (inc. Previous self-harm)",
        clininicallyDiagnosedIllness:
          "Clinically diagnosed short-term/long-term illness",
        disability: "Disability",
        stress:
          "Employment/educational/exam stress (inc. Learning difficulties)",
        financialIssues: "Financial issues (inc. Gambling debts)",
        genderIdentityIssues: "Gender identity issues",
        traumaHistory: "History of Trauma (inc. Adverse Childhood Experiences)",
        housingIssues: "Housing issues",
        militaryHistory: "Military history",
        natalConcerns: "Post / perinatal concerns",
        previousConvictions: "Previous convictions (inc. Imprisonment)",
        previouslySectioned: "Previously sectioned",
        relationshipIssues:
          "Relationship issues (family/partner/friend/social isolation)",
        sexualOrientationIssues: "Sexual orientation issues",
        domesticAbuse: "Domestic abuse victim, witness or suspect",
        suspectedSeriousCrime:
          "Suspected and/or survivor of serious crime (inc. Child sex crime, sexual, domestic abuse etc)",
        other: "Other (please specify)",
      },
    },
    describeRiskFactorsOther: "Please describe the additional risk factors",
    describeRiskFactorsOtherRequired:
      "Please provide details of other risk factors not listed",
  },
  mcaPersonDetails: {
    title: "Person Details",
    relativeOrFriendRelationship: "Relationship to person being assessed",
    relativeOrFriendRelationshipRequired:
      "Please confirm relationship to person being assessed",
    relativeOrFriendSameAddress:
      "Is the home address of the relative or friend the same as the person being assessed?",
    relativeOrFriendSameAddressRequired:
      "Please confirm if the relative/friend and person being assessed have the same home address",
    relativeOrFriendInformed:
      "Has the relative or friend been informed of the situation?",
    relativeOrFriendInformedRequired:
      "Please confirm if relative or friend has been informed of the situation",
  },
  /**
   * Recording a custody suite by name and by the force accountable for it,
   * for forces that use whichever suite is nearest rather than a fixed list
   * of their own.
   */
  custodySuite: {
    name: "Please confirm name of Custody Suite used",
    nameRequired: "Please confirm the name of the Custody Suite used",
    responsibleForce: {
      title: "What Police Force is responsible for this Custody Suite?",
      required:
        "Please select the Police Force responsible for this Custody Suite",
      options: {
        avonAndSomerset: "Avon and Somerset",
        bedfordshire: "Bedfordshire",
        cambridgeshire: "Cambridgeshire",
        cheshire: "Cheshire",
        cityOfLondon: "City of London",
        cleveland: "Cleveland",
        cumbria: "Cumbria",
        derbyshire: "Derbyshire",
        devonAndCornwall: "Devon and Cornwall",
        dorset: "Dorset",
        durham: "Durham",
        dyfedPowys: "Dyfed-Powys",
        essex: "Essex",
        gloucestershire: "Gloucestershire",
        greaterManchester: "Greater Manchester",
        gwent: "Gwent",
        hampshire: "Hampshire",
        hertfordshire: "Hertfordshire",
        humberside: "Humberside",
        kent: "Kent",
        lancashire: "Lancashire",
        leicestershire: "Leicestershire",
        lincolnshire: "Lincolnshire",
        merseyside: "Merseyside",
        metropolitanPolice: "Metropolitan Police",
        norfolk: "Norfolk",
        northWales: "North Wales",
        northYorkshire: "North Yorkshire",
        northamptonshire: "Northamptonshire",
        northumbria: "Northumbria",
        nottinghamshire: "Nottinghamshire",
        southWales: "South Wales",
        southYorkshire: "South Yorkshire",
        staffordshire: "Staffordshire",
        suffolk: "Suffolk",
        surrey: "Surrey",
        sussex: "Sussex",
        thamesValley: "Thames Valley",
        warwickshire: "Warwickshire",
        westMercia: "West Mercia",
        westMidlands: "West Midlands",
        westYorkshire: "West Yorkshire",
        wiltshire: "Wiltshire",
        policeScotland: "Police Scotland",
        psni: "Police Service of Northern Ireland (PSNI)",
        britishTransportPolice: "British Transport Police",
        ministryOfDefencePolice: "Ministry of Defence Police",
        civilNuclearConstabulary: "Civil Nuclear Constabulary",
      },
    },
  },
  mcaIncidentDetails: {
    title: "Incident Details",
    timeOfIncident: "Time of incident",
    dateOfIncident: "Date of incident",
    incidentLocation: "Location of incident",
    incidentLocationRequired: "Please enter the location of the incident",
    bcuIncidentTookPlace: "In which BCU did the incident happen?",
    bcuIncidentTookPlaceRequired:
      "Please select the BCU where the incident happened",
    locationType: {
      title: "What type of location was this?",
      required: "Please select the type of location",
      options: {
        homeAddress: "Home address",
        railwayLines: "Railway lines",
        hospitalWards: "Hospital wards",
        placeOfHeight: "Place of height",
        policeStationsCustody: "Police stations/Custody",
        offices: "Offices",
        school: "School",
        street: "Street",
        park: "Park",
        hotel: "Hotel",
        nonResidentialPartsRestrictedEntry:
          "Communal areas in multiple-occupant accommodation",
        emergencyDepartment: "Emergency Department",
        physicalHealthInpatientWard:
          "Hospital wards - Physical health Inpatient Ward",
        bridgeOverWater: "Bridge - over water",
        bridgeOverRoad: "Bridge - over road",
        noneOfTheAbove: "None of the above",
      },
      /**
       * The same question asked of a force whose ground is the rail network. A
       * separate set rather than a per-force override of `options`, because the
       * two lists name different places, not the same places differently.
       */
      railwayOptions: {
        homeAddress: "Home Address",
        policeStationsCustody: "Police Station/Custody",
        onTrain: "On Train",
        concourse: "Concourse",
        platform: "Platform",
        stationToilet: "Station Toilet",
        stationForecourt: "Station Forecourt",
        carPark: "Car Park",
        onTracksAtStation: "On Tracks at Station",
        onTracksAwayFromStation: "On Tracks Away from Station",
        lineside: "Lineside",
        bridge: "Bridge",
        levelCrossing: "Level Crossing",
        disusedRailwayOrStation: "Disused Railway or Station",
        tunnel: "Tunnel",
        depot: "Depot",
        otherRailwayInfrastructure: "Other Railway Infrastructure",
        offBtpJurisdiction: "Off BTP Jurisdiction",
        btpOffice: "BTP Office",
        ticketBarriers: "Ticket Barriers",
        hotelWithinRailwayEnvironment: "Hotel Within Railway Environment",
        publicHouse: "Public House",
        other: "Other",
      },
    },
    dateTimeOfIncidentRequired:
      "Please enter the date and time of the incident",
  },
  mcaCapacityAssessment: {
    title: "Capacity Assessment",
    introductionBanner:
      "Before recording use of restraint under section 5-6 of the MCA, you must first evidence the lack of capacity to make a best-interest decision at this time.",
    assessingIndividual: "Who is assessing the capacity of the individual?",
    assessingIndividualRequired:
      "Please select who is conducting the capacity assessment",
    assessingIndividualDescriptionBanner:
      "This could be yourself, London Ambulance Service or someone else. If another officer is the decision maker you may wish to transfer the form to them to complete. ",
    healthServiceAssessorDescriptionBanner:
      "You must obtain the relevant information from health professionals in order to complete the following questions.\nTo implement Sections 5-6 of the MCA you must be satisfied that the person lacks capacity, and a best interests decision has been made.",
    reportingOfficer: "Reporting officer",
    ambulanceService: "Ambulance Service",
    localTriageService: "Local triage service",
    other: "Other",
    ambulanceStaffName: "Full name of Ambulance staff",
    ambulanceStaffNameRequired:
      "Please provide the full name of the Ambulance staff",
    otherAssessor: "Please specify other",
    otherAssessorRequired: "Please specify who is conducting the assessment",
    decisionUnableToMake:
      "What decision does the person lack the capacity to make?",
    decisionUnableToMakeRequired:
      "Please describe the decision the person is unable to make",
    decisionUnableToMakeBanner:
      "Try to be specific, such as: to seek medical attention, to attend hospital, to move to a safer location",
    canUnderstandInformation:
      "1. Is the person able to <underline>understand</underline> the relevant information (including risks) needed to make the decision?",
    canUnderstandInformationRequired:
      "Please confirm whether the person can understand the relevant information",
    canUnderstandInformationReasoning: "Record reasoning",
    canUnderstandInformationReasoningRequired:
      "Please record your reasoning about the person's ability to understand",
    canRetainInformation:
      "2. Can the person <underline>retain</underline> the relevant information (including risks) long enough to make a decision about it?",
    canRetainInformationRequired:
      "Please confirm whether the person can retain the relevant information",
    canUnderstandInformationBanner:
      "Have you attempted to provide the information in a way the person can understand? Does the person appear to have a general understanding of the decision to be made? ",
    canRetainInformationReasoning: "Record reasoning",
    canRetainInformationReasoningRequired:
      "Please record your reasoning about the person's ability to retain information",
    canRetainInformationBanner:
      "Are they able to remember the information you tell them long enough to make a decision? For example, are they able to concentrate or pay attention to the information?",
    canWeighInformation:
      "3a. Can the person <underline>weigh</underline> the relevant information (including risks) as part of making a decision?",
    canWeighInformationRequired:
      "Please confirm whether the person can weigh the relevant information",
    canWeighInformationBanner:
      "Can they consider the potential consequences of deciding one way or the other, or of not making a decision at all? Note: people are allowed to make an unwise decision (provided they fully understand the risks and consequences)",
    canWeighInformationReasoning: "Record reasoning",
    canWeighInformationReasoningRequired:
      "Please record your reasoning about the person's ability to weigh information",
    canUseInformation:
      "3b. Can the person <underline>use</underline> the relevant information as part of making the decision?",
    canUseInformationRequired:
      "Please confirm whether the person can use the relevant information",
    canUseInformationBanner:
      "Can they implement their decision? For example, a person with a head injury may understand the need (weigh) but be unable to act on it (use).",
    canUseInformationReasoning: "Record reasoning",
    canUseInformationReasoningRequired:
      "Please record your reasoning about the person's ability to use information",
    canCommunicateDecision:
      "4. Is the person able to <underline>communicate</underline> their decision?",
    canCommunicateDecisionRequired:
      "Please confirm whether the person can communicate their decision",
    canCommunicateDecisionBanner:
      "Communication can be by any means, for example, talking, writing or gestures.",
    canCommunicateDecisionReasoning: "Record reasoning",
    canCommunicateDecisionReasoningRequired:
      "Please record your reasoning about the person's ability to communicate",
    impairmentDisturbance:
      "5. Do you consider that the person is unable to either understand, retain, use and weigh or communicate their decision because of an impairment or disturbance in the functioning of the mind or brain?",
    impairmentDisturbanceRequired:
      "Please confirm if 'no' answers are because of an impairment or disturbance in the mind or brain",
    impairmentDisturbanceInfoBannerBody:
      "Review your answers above. If you have answered <bold>NO</bold> to any of the questions 1-4, you need to assess whether this is because of an impairment/disturbance in how the person's mind or brain is working. It doesn't matter if the impairment or disturbance is temporary or permanent.\nExamples of an impairment or disturbance in the functioning of the mind or brain may include the following:<ul><li>the long-term effects of brain damage</li><li>physical or medical conditions that cause confusion, drowsiness or loss of consciousness</li><li>delirium</li><li>concussion following a head injury</li><li>the symptoms of alcohol or drug use</li><li>conditions associated with some forms of mental illness</li><li>dementia</li><li>significant learning disabilities</li></ul>This is distinct from a belief that their behaviour is caused by mental ill health, in which case the Mental Health Act would need to be considered instead of the Mental Capacity Act.",
    impairmentType: {
      title: "What impairment do they appear to have?",
      required: "Please describe what impairment the person appears to have",
      banner:
        "Examples of an impairment or disturbance in the functioning of the mind or brain may include the following:<ul><li>the long-term effects of brain damage</li><li>physical or medical conditions that cause confusion, drowsiness or loss of consciousness</li><li>delirium</li><li>concussion following a head injury</li><li>the symptoms of alcohol or drug use</li><li>conditions associated with some forms of mental illness</li><li>dementia</li><li>significant learning disabilities</li></ul>This is distinct from a belief that their behaviour is caused by mental ill health, in which case the Mental Health Act would need to be considered instead of the Mental Capacity Act.",
    },
    lackOfCapacityWarningBanner:
      "If you have found the answer is <bold>NO</bold> to any of questions 1 - 4  and <bold>YES</bold> to question 5, then you have found the person to lack capacity to make the decision at this time. If you have not found the person to lack capacity, you must still complete the remainder of the form but you cannot use Section 5-6 Mental Capacity Act.",
    lackOfCapacity:
      "Based on your answers to questions 1-5, have you - or a health professional - determined a lack of capacity to make the decision at this time?",
    lackOfCapacityRequired:
      "Please confirm whether you have determined a lack of capacity",
    earlyExitCapable: {
      body: "As you have found the person is able to make their own decision, would you like to end the form?",
      end: "End form",
      continue: "Continue form",
      required: "Please select whether to end or continue the form",
    },
    earlyExitNoImpairment: {
      body: "As you have found that the person's functional limitations are not due to an impairment in the mind or brain, would you like to end the form?",
      end: "End form",
      continue: "Continue form",
      required: "Please select whether to end or continue the form",
    },
    earlyExitNoLackOfCapacity: {
      body: "As you have not found the person to lack capacity to make the decision at this time, would you like to end this mental capacity form?",
      end: "End form",
      continue: "Continue form",
      required: "Please select whether to end or continue the form",
    },
    reasoningLackOfCapacity: {
      title:
        "Record your reasoning for why you believe the person lacks capacity to make the decision at this time",
      required:
        "Please record your reasoning for determining a lack of capacity",
      banner:
        "Summarise in your own words, the reasons why the person lacks capacity at this time.",
    },
    bestInterestSteps: "What steps did you take to determine best interest? ",
    bestInterestStepsRequired:
      "Please describe the steps you took to determine best interest",
    bestInterestStepsInfoBanner:
      "For example, have you considered the person's wishes and feelings and/or consulted and taken account of the views of others.",
    bestInterestPhysicalHealthCondition:
      "Was the best-interests assessment - and the action taken - specifically in relation to a physical health condition?",
    bestInterestPhysicalHealthConditionRequired:
      "Please confirm whether the best-interests assessment was specifically in relation to a physical health condition",
    bestInterestPhysicalConditionDescription:
      "Please describe the physical condition that required attendance at an Emergency Department",
    bestInterestPhysicalConditionDescriptionRequired:
      "Please describe the physical condition",
    bestInterestExceptionalCircumstances:
      "Please outline the exceptional circumstances that led you to intervene, and specify any advice or direction you received from health professionals",
    bestInterestExceptionalCircumstancesRequired:
      "Please outline the exceptional circumstances",
    bestInterestAct:
      "What act was necessary and why was this in the person's best interest? ",
    restraintNecessary:
      "Is the restraint necessary to prevent harm to themselves proportionate and in the person's best interest?",
    noRestraintUsed: "No restraint used",
    restraintRiskInfoBanner:
      "Please explain the seriousness and likelihood of the risk that you were trying to prevent.",
    restraintRiskReasoning: "Record reasoning",
    restraintRiskReasoningRequired:
      "Please record your reasoning about restraint and risk",
    bestInterestActRequired:
      "Please describe the act and why it was in the person's best interest",
    restraintNecessaryRequired:
      "Please confirm whether restraint was necessary and proportionate",
    useOfForceType: {
      title: "What type of force was used? Select all that apply",
      required: "Please select at least one type of force used",
      options: {
        handcuffing: "Handcuffing (compliant and non-compliant)",
        unarmedSkills:
          "Unarmed skills (including pressure points, strikes, restraints and take-downs)",
        dogs: "Use of dogs",
        baton: "Drawing or use of baton",
        irritantSpray: "Drawing or use of irritant spray",
        limbBodyRestraints: "Limb/body restraints",
        spitGuard: "Spit guard",
        shield: "Shield",
        ced: "Conductive Energy Device (CED - Taser) in any of the seven categories of use",
        aep: "AEP: drawn or discharged",
        firearms: "Firearms: drawn or discharged",
        otherImprovised: "Other/improvised",
        handcuffingCompliant: "Handcuffing (compliant)",
        handcuffingNonCompliant: "Handcuffing (non-compliant)",
        tacticalCommunication: "Tactical communication",
        dogBite: "Dog bite",
        groundRestraint: "Ground restraint",
      },
    },
  },
  mcaAccompaniment: {
    title: "Accompaniment",
    accompanyingToEmergencyDepartment:
      "Are the police accompanying the person to an Emergency Department (A&E)?",
    accompanyingToEmergencyDepartmentRequired:
      "Please indicate whether the police are accompanying the person to an Emergency Department",
    notAccompanyingReason: "Please explain why",
    notAccompanyingReasonRequired:
      "Please explain why you are not accompanying the person to the Emergency Department",
    notAccompanyingInstructionsBanner:
      "If you are not accompanying the person to the Emergency Department (A&E), complete the remainder of this form and end the incident. A PDF of the form is available once ended. Alternatively, transfer this form to the next responsible officer.",
    personLeftInCareOf: "Who are you leaving the person in the care of?",
    personLeftInCareOfRequired:
      "Please indicate who you are leaving the person in the care of",
    personLeftInCareOfBanner:
      "As the person is not being accompanied to the Emergency Department (A&E), indicate who you are leaving the person with. If not applicable, briefly summarise why.",
  },
  placeOfSafetyPicker: {
    manuallyEnter: "Manually enter",
    name: "Name",
    name_136: "Place of Safety Name",
    name_mca: "Emergency Department Name",
    address: "Address",
    address_136: "Address",
    address_mca: "Address",
    postalCode: "Postal Code",
    errorNotFound:
      "Place of Safety not found. Please make a selection from the dropdown list",
    errorNotFound_136:
      "Place of Safety not found. Please make a selection from the dropdown list",
    errorNotFound_mca:
      "Emergency Department not found. Please make a selection from the dropdown list",
    selectManualEnter:
      "Manually enter details if your Place of Safety is not found",
    selectManualEnter_136:
      "Manually enter details if your Place of Safety is not found",
    selectManualEnter_mca:
      "Manually enter details if your Emergency Department is not found",
    outsideForceAreaWarning:
      "This Place of Safety is outside of your force's area, please ensure you have made the right selection",
    outsideForceAreaWarning_136:
      "This Place of Safety is outside of your force's area, please ensure you have made the right selection",
    outsideForceAreaWarning_mca:
      "This Emergency Department is outside of your force's area, please ensure you have made the right selection",
    loadError:
      "The list could not be loaded. Please check your connection, or enter the details manually below.",
    retry: "Try again",
  },

  transfer: {
    initiateTransfer: {
      title: "Transfer to another officer?",
      transferIncidentWorkItem: "You are about to transfer",
      transferIncidentWorkItemId: "You are about to transfer incident ID:",
      confirmedTransfer:
        "Once you have confirmed the transfer, the <bold>receiving officer must accept the form</bold> for the transfer to complete.",
      untilTransferAccepted:
        "Until the transfer is accepted, the form will remain your responsibility.",
      adminUntilTransferAccepted:
        "Until the transfer is accepted, the form will remain the current responsible officer's responsibility.",
      enterEmailAddress: "Enter officer's email address",
      confirm: "Confirm Transfer",
      confirmToast: "Incident transferred to {{ email }}",
    },
    rejectedTransfer: {
      title: "Transfer to another officer",
      declinedMessage:
        "Officer {{officerName}} has declined the 136 form you transferred to them.",
      tryAgain: "Would you like to try transferring again?",
    },
    transferDeclined: "Transfer has been declined",
    requestedTransfer: {
      title: "Accept form transfer?",
      officerRequest:
        "A form with the following details has been transferred to you, pending your acceptance",
      createdAt: "Created at",
      nameOfPerson: "Name of person",
      incidentId: "Incident ID",
      officerAssigned: "Officer Assigned",
      accept: "Accept & View",
      reject: "Reject",
    },
  },

  reviewBeforeEnding: {
    title: "Review before ending",
    dataMissing: "Data missing",
    closeAriaLabel: "close",
    introText:
      "You are ending the form. You won't be able to edit the form or complete a digital handover once the form is ended.",
    ensureDetails: "Please ensure the details below are correct:",
    latestPlaceOfSafetyLabel: "Latest Place of Safety:",
    latestPlaceOfSafetyLabel_136: "Latest Place of Safety:",
    latestPlaceOfSafetyLabel_mca: "Latest Emergency Department:",
    notRecorded: "Not recorded",
    update: "UPDATE",
    latestPolicePresenceEntryLabel: "Latest Police Presence entry:",
    lastUpdated: "Last Updated:",
    continue: "CONTINUE",
  },
  finishForm: {
    confirmEndForm: {
      title: "Please confirm you want to end the form.",
    },
    whyNotSharing: {
      title: "Why did you not share the form with the NHS?",
      required: "Please specify",
      options: {
        nhsUsingOtherProcess: "NHS insisted on using other form/process",
        internetConnection: "Internet connectivity issues",
        emailNotReceived: "Email not received",
        other: "Other (please specify)",
      },
    },
    whyNotSharingOther: {
      title: "Please specify",
      required: "Please specify",
    },
    staffNameLeftWith: {
      title:
        "Name of NHS staff member receiving the person subject to the Mental Capacity Act.",
      required: "$t(common.required)",
    },
    informStaff: "Please inform staff at the place of safety before leaving.",
    informStaff_136:
      "Please inform staff at the place of safety before leaving.",
    informStaff_mca:
      "Please inform staff at the emergency department before leaving.",
    finishFormTitle: "Finish Form",
    leavePlaceOfSafety: "Leave Place of Safety?",
    leavePlaceOfSafety_136: "Leave Place of Safety?",
    leavePlaceOfSafety_mca: "Finish Form",
    dutyOfCare: "Please inform staff at the place of safety before leaving.",
    dutyOfCare_136:
      "Please inform staff at the place of safety before leaving.",
    dutyOfCare_mca:
      "Please inform staff at the emergency department before leaving.",
    dateLeft: "Date police left",
    timeLeft: "Time police left",
    totalPosTime: "Police Time at Place(s) of Safety",
    totalPosTime_136: "Police Time at Place(s) of Safety",
    totalPosTime_mca: "Police Time at Emergency Department(s)",
    incidentDurationExplainer:
      "Calculated from date/time arrival at first POS to date/time left final POS",
    incidentDurationExplainer_136:
      "Calculated from date/time arrival at first POS to date/time left final POS",
    incidentDurationExplainer_mca:
      "Calculated from date/time arrival at first ED to date/time left final ED",
    confirmDateTimeLeaving: "I confirm the date/time of leaving is correct",
    confirmDateTimeLeavingRequired: "Please confirm the date/time you left",
    wasPersonAssessed:
      "Was this person assessed for their mental health at a Place of Safety?",
    wasPersonAssessed_136:
      "Was this person assessed for their mental health at a Place of Safety?",
    wasPersonAssessed_mca:
      "Was this person assessed for their mental health at an Emergency Department?",
    assessmentOutcomeKnown: "Do you know the outcome of the assessment?",
    whatWasTheOutcome: {
      title: "What was the outcome?",
      options: {
        discharged: "Discharged",
        admitted: "Admitted",
        other: "Other (e.g. local community care)",
      },
      otherOutcome: "Please specify the outcome",
    },

    whatWasTheOutcome136: {
      title: "What was the outcome of the Section 136 incident?",
      options: {
        noDisorder: "Medical examination confirmed no mental disorder",
        signpostedSupport: "Person signposted to community support",
        voluntaryAdmission: "Informal Admission (Voluntary)",
        section2Detained: "Formally detained under Section 2 MHA",
        section3Detained: "Formally detained under Section 3 MHA",
        unknownHandover: "Unknown - Handover of care before assessment",
        unknownExpired:
          "Unknown - Maximum detention period expired before assessment",
      },
    },

    typeOfFurtherCareReceived: {
      title: "Please confirm what type of further care they received",
      options: {
        furtherDetention: "Further detention under the mental health act",
        voluntary: "Voluntary",
        unknown: "Don't know",
      },
    },
  },
  endIncidentCommon: {
    incidentLeaveDatePos: "What date did you leave?",
    incidentLeaveTimePos: "What time did you leave?",
    incidentLeaveDateTimePosRequired:
      "Please confirm the date/time you left the final POS",
    incidentOutcome: {
      title: "What was the outcome of the section 136 incident?",
      required: "Please confirm the outcome of the Section 136 Incident",
      options: {
        mentalExamination: "Medical examination confirmed no mental disorder",
        informationAdmission:
          "Information provided to support informal admission",
        signpostedToCommunity: "Person signposted to community support",
        informalAdmission: "Informal admission (Voluntary)",
        section2Detention: "Formally detained Section 2 (MHA)",
        section3Detention: "Formally detained Section 3 (MHA)",
        unknownHandover: "Unknown - Handover of care before assessment",
        unknownMaximumDetention:
          "Unknown - Maximum detention period expired before assessment",
      },
    },
  },
  preEndIncident: {
    warningBanner:
      "This process is irreversible. You won't be able to edit the form or complete a digital handover once the form is ended.",
    warningBanner_136:
      "This process is irreversible. You won't be able to edit the form or complete a digital handover once the form is ended.",
    warningBanner_mca:
      "This process is irreversible. You won't be able to edit the form once the form is ended.",
    endFormTitle: "End Form",
    whyEndingMcaForm: {
      title: "Why are you ending the form before completing all sections?",
      required: "Please select a reason for ending the form",
      options: {
        startedFormInError: "Started form in error",
        personHadCapacity:
          "Confirmed person has capacity to make their own decision at this time",
        other: "Other",
      },
    },
    whyEndingMcaFormOther: {
      title: "Please specify",
      required: "Please specify",
    },
    endingReason: {
      title: "Why are you ending the form?",
      additionalInformation: "Please provide additional details",
      options: {
        startedFormInError: "Started form in error",
        formExpired: "Section 136 Expired",
        nhsNotEngage: "NHS organisation did not engage in digital form",
        medicalExamination: "Medical examination confirmed no mental disorder",
        other: "Other",
      },
    },
    whyFormExpired: {
      title: "Why did the Section 136 expire?",
      options: {
        noBedAvailable: "No bed available in time",
        delayedAssessment: "Delay in assessment being completed",
        processProblems: "Process problems (please specify)",
      },
      otherProcessProblems: "Please specify the process problems",
    },
    whyNhsNotEngage: {
      title: "Why did they not engage with digital form?",
      required: "$t(common.required)",
      options: {
        internetConnection: "Internet connectivity issues",
        startedFormInError: "Started form in error",
        nhsUsingOtherProcess: "NHS insisted on using other form/process",
        emailNotReceived: "Email not received",
        handoverCompletedVerbally:
          "No forms used locally, handover completed verbally",
        localForm: "Insisted on using local form/process ",
        other: "Other (please specify)",
      },
      additionalInformationNotEngage: "Please provide additional details",
      additionalInformationNotEngageRequired: "$t(common.required)",
    },
    wasAssessedMentalHealthPlaceOfSafety:
      "Was the person assessed for their mental health at a Place of Safety?",
    wasAssessedMentalHealthPlaceOfSafety_136:
      "Was the person assessed for their mental health at a Place of Safety?",
    wasAssessedMentalHealthPlaceOfSafety_mca:
      "Was the person assessed for their mental health at an Emergency Department?",
    wereAskedToRemainAtPosByHealthAmhp:
      "Were you asked to remain at the POS by health/AMHP?",
    wereAskedToRemainAtPosByHealthAmhp_136:
      "Were you asked to remain at the POS by health/AMHP?",
    wereAskedToRemainAtPosByHealthAmhp_mca:
      "Were you asked to remain at the ED by health/AMHP?",
    nhsRequestedPolicePresentAtPos:
      "Has the NHS requested ongoing police presence at the Place of Safety?",
    nhsRequestedPolicePresentAtPos_136:
      "Has the NHS requested ongoing police presence at the Place of Safety?",
    nhsRequestedPolicePresentAtPos_mca:
      "Has the NHS requested ongoing police presence at the Emergency Department?",
    nhsRequestedPolicePresentAtPosRequired:
      "Please confirm if the NHS has asked for ongoing police presence at the Place of Safety",
    nhsRequestedPolicePresentAtPosRequired_136:
      "Please confirm if the NHS has asked for ongoing police presence at the Place of Safety",
    nhsRequestedPolicePresentAtPosRequired_mca:
      "Please confirm if the NHS has asked for ongoing police presence at the Emergency Department",
    remainedAtPos: "Will you remain or have you remained at the POS?",
    remainedAtPos_136: "Will you remain or have you remained at the POS?",
    remainedAtPos_mca: "Will you remain or have you remained at the ED?",
    remainedAtPosRequired: "Please confirm if you will stay at the POS",
    remainedAtPosRequired_136: "Please confirm if you will stay at the POS",
    remainedAtPosRequired_mca: "Please confirm if you will stay at the ED",
    remainedAtPosReasoning:
      "Please add the reasoning or conditions for your response",
    remainedAtPosReasoningRequired:
      "Please add reasoning or conditions for your action",
    whoRequestedPolicePresence: "Who requested ongoing police presence?",
    whoRequestedPolicePresenceReason:
      "Please add first and last name of the person who asked you to stay at the POS",
    whoRequestedPolicePresenceReason_136:
      "Please add first and last name of the person who asked you to stay at the POS",
    whoRequestedPolicePresenceReason_mca:
      "Please add first and last name of the person who asked you to stay at the ED",
    reasonForPolicePresenceRequest: {
      title:
        "What reason were you given for why ongoing police presence was needed?",
      required:
        "Please select what reason they gave you for staying at the POS",
      required_136:
        "Please select what reason they gave you for staying at the POS",
      required_mca:
        "Please select what reason they gave you for staying at the ED",
      options: {
        notEnoughStaff: "Not enough staff",
        immediateRiskToLifeOrOfSeriousHarm:
          "To protect people from an immediate risk to life, or being subject to/at risk of serious harm",
        transferred:
          "Person to be transferred to another place of safety for assessment",
        transferred_136:
          "Person to be transferred to another place of safety for assessment",
        transferred_mca:
          "Person to be transferred to another emergency department for assessment",
        other: "Other",
      },
      additionalInformation:
        "Please provide additional details on why this reason was given, including any risk assessments done by the NHS",
      additionalInformationRequired:
        "Please add further details of their reasoning",
      ifDisagreeBanner:
        "If you do not agree with this rationale you should seek the assistance of a supervisor, however you must remain until a safe handover has been agreed",
    },
    whatWillYouDo: {
      title: "What will you do?",
      required:
        "Please select what action you took in response to NHS request to stay",
      options: {
        escalatedAndLeft: "Escalated and left",
        stayedAgreeWithNhs: "Stayed - agreed with NHS reasoning and staying",
        stayedDisagreeWithNhs:
          "Stayed - disagreeing with NHS reasoning and escalating",
      },
      additionalInformation:
        "Please add the reasoning or conditions for your actions",
    },
    remainedLongerAtPosDueToHealthAmhpRequest:
      "Did you remain longer at the POS due to health/AMHP request?",
    remainedLongerAtPosDueToHealthAmhpRequest_136:
      "Did you remain longer at the POS due to health/AMHP request?",
    remainedLongerAtPosDueToHealthAmhpRequest_mca:
      "Did you remain longer at the ED due to health/AMHP request?",
    didYouArriveAtPos: "Did you arrive at a POS?",
    didYouArriveAtPos_136: "Did you arrive at a POS?",
    didYouArriveAtPos_mca: "Did you arrive at an ED?",
    hasHandoverOccurred: "Has a handover occurred with the Place of Safety?",
    hasHandoverOccurred_136:
      "Has a handover occurred with the Place of Safety?",
    hasHandoverOccurred_mca:
      "Has a handover occurred with the Emergency Department?",
    incidentTimeArrivePos: "What time did you arrive at your first POS?",
    incidentTimeArrivePos_136: "What time did you arrive at your first POS?",
    incidentTimeArrivePos_mca: "What time did you arrive at your first ED?",
    incidentDateArrivePos: "What date did you arrive at your first POS?",
    incidentDateArrivePos_136: "What date did you arrive at your first POS?",
    incidentDateArrivePos_mca: "What date did you arrive at your first ED?",
    incidentDateHandover: "What date did you handover?",
    incidentTimeHandover: "What time did you handover?",
    informStaffBeforeLeaving:
      "Please inform staff at the place of safety before leaving.",
    informStaffBeforeLeaving_136:
      "Please inform staff at the place of safety before leaving.",
    informStaffBeforeLeaving_mca:
      "Please inform staff at the emergency department before leaving.",
    outcomeOfAssessment: "Do you know the outcome of the assessment?",
    selectedAssessmentOutcome: {
      title: "What was the outcome of the assessment?",
      otherOutcome: "Please specify the outcome",
      options: {
        discharged: "Discharged",
        admitted: "Admitted",
        other: "Other",
      },
    },
    furtherCareType: {
      title: "Please confirm what type of further care they received",
      options: {
        furtherDetention: "Further detention under the mental health act",
        voluntary: "Voluntary",
        unknown: "Don't know",
      },
    },
  },
  requestPolicePresence: {
    placeOfSafetyText: "Your latest Place of Safety",
    placeOfSafetyText_136: "Your latest Place of Safety",
    placeOfSafetyText_mca: "Your latest Emergency Department",
    healthProfessionalName: "Who requested ongoing police presence?",
    healthProfessionalNameRequired:
      "Please add first and last name of the person who asked you to stay at the Place of Safety",
    healthProfessionalNameRequired_136:
      "Please add first and last name of the person who asked you to stay at the Place of Safety",
    healthProfessionalNameRequired_mca:
      "Please add first and last name of the person who asked you to stay at the Emergency Department",
    healthProfessionalNamePlaceholder: "First and last name",
    wereYouAskedToStay:
      "Has the NHS requested ongoing police presence at the Place of Safety?",
    wereYouAskedToStay_136:
      "Has the NHS requested ongoing police presence at the Place of Safety?",
    wereYouAskedToStay_mca:
      "Has the NHS requested ongoing police presence at the Emergency Department?",
    wereYouAskedToStayRequired:
      "Please confirm if the NHS has asked for ongoing police presence at the Place of Safety",
    wereYouAskedToStayRequired_136:
      "Please confirm if the NHS has asked for ongoing police presence at the Place of Safety",
    wereYouAskedToStayRequired_mca:
      "Please confirm if the NHS has asked for ongoing police presence at the Emergency Department",
    policePresenceRequestedReason:
      "What reason were you given for this request?",
    policePresenceRequestedReasonRequired:
      "Please select what reason they gave you for staying at the Place of Safety",
    policePresenceRequestedReasonRequired_136:
      "Please select what reason they gave you for staying at the Place of Safety",
    policePresenceRequestedReasonRequired_mca:
      "Please select what reason they gave you for staying at the Emergency Department",
    furtherReasoning:
      "Please provide additional details on why this reason was given, including any risk assessments done by the NHS",
    furtherReasoningRequired: "Please add further details of their reasoning",
    furtherReasoningAdvice:
      "If you do not agree with this rationale you should seek the assistance of a supervisor, however you must remain until a safe handover has been agreed.",
    source: "Source",
    title: "Request Police Presence",
    dropdown: {
      immediateRiskToLifeOrOfSeriousHarm:
        "To protect people from an immediate risk to life, or being subject to/at risk of serious harm",
      notEnoughStaff: "Not enough staff",
      transfer:
        "Person to be transferred to another place of safety for assessment",
      transfer_136:
        "Person to be transferred to another place of safety for assessment",
      transfer_mca:
        "Person to be transferred to another emergency department for assessment",
      other: "Other",
    },
    emhaTeamId: "EMHA Team ID",
    emhaTeamName: "EMHA Team Name",
    createdAt: "Created At",
    emhaUserId: "EMHA User ID",
    emhaUserName: "EMHA User Name",
    emhaOrganisationId: "EMHA Organisation ID",
    emhaOrganisationName: "EMHA Organisation Name",
    alreadyLeft: "Already Left",
  },
  recordPolicePresence: {
    title: "Record Police Presence",
    remainedAtPlaceOfSafety:
      "Have you remained, or will you remain, at the Place of Safety?",
    remainedAtPlaceOfSafety_136:
      "Have you remained, or will you remain, at the Place of Safety?",
    remainedAtPlaceOfSafety_mca:
      "Have you remained, or will you remain, at the Emergency Department?",
    remainedAtPlaceOfSafetyRequired:
      "Please confirm if the NHS has asked for ongoing police presence at the Place of Safety",
    remainedAtPlaceOfSafetyRequired_136:
      "Please confirm if the NHS has asked for ongoing police presence at the Place of Safety",
    remainedAtPlaceOfSafetyRequired_mca:
      "Please confirm if the NHS has asked for ongoing police presence at the Emergency Department",
    reasoning: "Please add the reasoning or conditions for your actions",
    createdAt: "Created At",
    whatWillYouDo: "What action have you taken in response to NHS request?",
    whatWillYouDoRequired:
      "Please select what action you took in response to NHS request to stay",
    escalatedAndLeft: "Escalated and left",
    stayedAgreeWithNhs: "Stayed - Agree with NHS reasoning",
    stayedDisagreeWithNhs:
      "Stayed - disagree with NHS reasoning, and escalated to supervisor",
  },
  notification: {
    failedRetrieve: "Failed to retrieve notifications",
    s136Accepted: "Section 136 incident accessed",
    s136Accepted_mca: "MCA form accessed",
  },
  s136FormRejectedNotification: {
    s136Rejected: "Section 136 incident rejected",
    s136Rejected_mca: "MCA form rejected",
    formDeclined: "Form Access Declined",
    formRejected: "Form rejected",
    formRjectedBy: "Form rejected by:",
    reason: "Reason:",
    reshareForm:
      "Please reshare form with another place of safety to continue the incident",
    reshareForm_136:
      "Please reshare form with another place of safety to continue the incident",
    reshareForm_mca:
      "Please reshare form with another emergency department to continue the incident",
    reshare: "reshare",
  },
  policePresenceNotification: {
    requested: "Police presence requested",
    policePresenceRequestByNHS: "Police presence request by NHS",
    submittedInformation:
      "The following information has been submitted by professionals involved in this Section 136. Green inputs reflect information provided by a healthcare practitioner.",
    safetyMessage:
      "If the above is wrong or you do not agree with the rationale of this request you should communicate with the NHS and seek the assistance of a supervisor.",
    safetyMessageBody: "Do not leave unless a safe handover has been agreed.",
    requestedMessage:
      "{{requesterName}} has requested ongoing police presence at {{posName}} with the following reason:",
    next: "Next",
    okay: "Okay",
    options: {
      immediateRiskToLifeOrOfSeriousHarm:
        "To protect people from an immediate risk to life, or being subject to/at risk of serious harm",
      notEnoughStaff: "Not enough staff",
      transfer:
        "Person to be transferred to another place of safety for assessment",
      transfer_136:
        "Person to be transferred to another place of safety for assessment",
      transfer_mca:
        "Person to be transferred to another emergency department for assessment",
      other: "Other",
    },
  },
  supervisor: {
    tabs: {
      incidents: "Incidents",
      dashboards: "Dashboards",
      dataGlossary: "Data Glossary",
      v1Dashboard: "V1 Dashboard",
    },
    dashboard: {
      notConfigured: "Dashboard is not configured for this organisation.",
      notSupervisor:
        "You need to be a supervisor to view dashboards. Please switch to a role where you are a supervisor.",
      noData: "No dashboard data available.",
      errorLoading: "Error loading dashboard: {{error}}",
      parseError: "Failed to parse dashboard configuration",
      fetchError: "Failed to fetch dashboard configuration",
      download: "Download",
      exporting: "Exporting...",
      exportError: "Failed to export dashboard",
      downloadPdf: "Download as PDF",
      downloadImage: "Download as Image",
    },
    powerBiDashboard: {
      deprecationWarning:
        "This dashboard uses data from the original Thalamos Form 434 and includes Section 136 pathway data collected by officers between 1 June 2022 and 20 May 2026. To view MH Forms data from 20 May 2026 onwards, please refer to the current dashboard.",
      notConfigured: "V1 Dashboard is not configured for this organisation.",
      noData: "No V1 Dashboard data available.",
      errorLoading: "Error loading V1 Dashboard: {{error}}",
      fetchError: "Failed to fetch V1 Dashboard configuration",
    },
  },
  admin: {
    tabs: {
      incidents: "Incidents",
      organisations: "Organisations",
      userList: "User List",
      locationPrecisionOverrides: "Location Precision",
      userDirectoryInstances: "User Directory Instances",
      supervisorSyncExemptions: "SUPERVISOR OVERRIDES",
    },
    dataGlossary: {
      title: "Data Definitions",
      term: "Term",
      definition: "Definition",
      dataContext: "Data Context",
      calculation: "Calculation",
      cleaningRules: "Cleaning Rules",
      notes: "Notes",
      recordedOn: "Recorded On",
    },
    userDirectoryInstances: {
      addInstance: "Add User Directory Instance",
      organisation: "Organisation",
      actions: "Actions",
      edit: "Edit",
      delete: "Delete",
      deleteInstance: "Delete User Directory Instance",
      deleteInstanceAreYouSure:
        "Are you sure you want to delete the user directory instance for <1>{{orgName}}</1>?",
      deleteSuccess: "User directory instance deleted successfully",
      deleteError: "Failed to delete user directory instance",
      createInstance: "Create User Directory Instance",
      updateInstance: "Update User Directory Instance",
      tenantId: "Tenant ID",
      clientId: "Client ID",
      clientSecret: "Client Secret",
      userDirectoryKey: "User Directory Key",
      auth0ConnectionId: "Auth0 Connection ID",
      auth0ConnectionIdHelperText:
        "If provided, Azure credentials below are optional",
      supervisorMapping: "Supervisor Mapping",
      graphGroupMapping: "Graph Group Mapping",
      graphGroupId: "Graph API Group ID",
      commandUnit: "Command Unit",
      addGraphGroupMapping: "Add Graph Group Mapping",
      duplicateGraphGroupId:
        "Duplicate group ID - each group may only appear once",
      commandUnitMapping: "Command Unit Mapping",
      commandUnitNames: "Command Unit Names",
      addCommandUnitMapping: "Add Command Unit Mapping",
      create: "Create",
      update: "Update",
      createSuccess: "User directory instance created successfully",
      createError: "Failed to create user directory instance",
      updateSuccess: "User directory instance updated successfully",
      updateError: "Failed to update user directory instance",
      notRequiredForAuth0: "Not required for Auth0 connections",
      shoulderNumberMappingField:
        "Shoulder Number Mapping Field (Auth0 claim name)",
      shoulderNumberMappingFieldHelperText:
        "The name of the Auth0/SCIM user attribute that contains the shoulder/warrant number (e.g. shoulder_number)",
      shoulderNumberValidationRegex: "Shoulder Number Validation Regex",
      shoulderNumberValidationRegexHelperText:
        "Optional regular expression used to validate the shoulder number before syncing. Leave blank to accept all values.",
      groupSyncDelayMinutes: "Group Sync Delay (minutes)",
      groupSyncDelayMinutesHelperText:
        "Number of minutes after the main sync before the group sync job runs. Required when a graph group mapping is configured.",
      groupSyncDelayMinutesRequired:
        "Group sync delay is required when a graph group mapping is configured.",
      groupSyncDelayMinutesInvalid: "Enter a whole number greater than 0",
    },
    incidents: {
      incidentType: "Incident Type",
      force: "Force",
      division: "Division",
      incidentStatus: "Incident Status",
      duration: "Time at POS",
      s136DurationTooltip:
        "Time at POS is calculated from the first date/time of arrival to when they left, as input by officers",
      officerName: "Officer name",
      arrivalTime: "Arrival date/time",
      notArrived: "Not Arrived",
      organisations: "Organisations",
      incidentNumber: "Dispatch Number (e.g. CW or CAD)",
      responsibleOfficer: "Responsible Officer email",
      sectorId: "Sector ID",
      latestPos: "Latest Place of Safety",
      latestPos_136: "Latest Place of Safety",
      latestPos_mca: "Latest Emergency Department",
      unknown: "Unknown",
      section136: "Section 136",
      other: "Other",
      notAdded: "Not added",
      actions: "Actions",
      action: "Action",
      latestPosTooltip:
        "This is the Place of Safety with the most recent arrival time, as entered by the responsible officer",
      latestPosTooltip_136:
        "This is the Place of Safety with the most recent arrival time, as entered by the responsible officer",
      latestPosTooltip_mca:
        "This is the Emergency Department with the most recent arrival time, as entered by the responsible officer",
      posArrivalTooltip:
        "This is the time that the officer said they entered through the doors of the POS",
      posArrivalTooltip_136:
        "This is the time that the officer said they entered through the doors of the POS",
      posArrivalTooltip_mca:
        "This is the time that the officer said they entered through the doors of the ED",
      cancelTransfer: "Cancel Transfer",
      transfer: "Transfer",
      searchOfficerNameLabel: "Officer name",
      searchDispatchLabel: "Dispatch number",
      incidentCreatedDate: "Incident Created Date",
      sectionMca: "Mental Capacity",
      voluntary: "Voluntary",
      apply: "Apply",
      filters: "Filters",
      clear: "Clear",
      cancelTransferModal: {
        title: "Cancel transfer to another officer?",
        content:
          "You are about to cancel a transfer to officer {{receivingOfficer}}. Are you sure you want to cancel?",
        confirmCancel: "Confirm Cancel",
        close: "Close",
      },
      downloadPdf: "Download PDF",
      downloadExtract: "Download Extract",
      downloadPdfFailed: "Failed to download PDF",
      downloadPdfError: "Error downloading PDF",
      downloadWithSnapshots: "Download all versions",
      downloadingSnapshots: "Preparing Download...",
      downloadSnapshotsStarted:
        "Preparing snapshot download. This may take a moment...",
      downloadSnapshotsReady: "Download ready!",
      downloadSnapshotsFailed: "Failed to start snapshot download",
      downloadSnapshotsError: "Error downloading snapshots",
      downloadSnapshotsTimeout: "Snapshot download timed out",
      downloadExtractModal: {
        title: "Download CSV Extract",
        content:
          "Select the timeframe for which you would like the report generated. Once selected you can generate and download the report.",
        cancel: "Cancel",
        download: "Download",
        startDate: "Start Date",
        endDate: "End Date",
        error: "Failed to download CSV extract",
        selectOrg: "Organisation",
        success: "CSV Extract successfully downloaded",
      },
    },
    users: {
      searchLabel: "Officer name or email",
      name: "Name",
      bulkCreateConfirm: "Are you sure you want to bulk create users?",
      responsibleOfficerEmail: "Responsible Officer Email",
      badgeNumber: "Badge Number",
      organisation: "Organisation",
      role: "Role",
      actions: "Actions",
      action: "Action",
      editProfile: "Edit Profile",
      editMemeberships: "Edit Memberships",
      deleteUser: "Delete User",
      deleteUserAreYouSure:
        "Are you sure you want to delete this user? This action cannot be undone.",
      deleteExceptionError: "Unexpected error while deleting user.",
      apiDeleteError: "Failed to delete user via the API.",
      modal: {
        title: "Edit User Memberships",
        message:
          "Please ensure the following information is correct before updating memberships",
        update: "Update Memberships",
        role: "Role",
        officer: "Officer",
        supervisor: "Supervisor",
        organisation: "Organisation",
        noMembership: "User does not have a membership",
        supervisorSyncExemptionBanner:
          "This user is exempt from automatic supervisor provisioning. Their supervisor memberships will not be modified by the nightly sync job.",
        supervisorSyncExemption:
          "Exempt from automatic supervisor provisioning",
        supervisorSyncExemptionTooltip:
          "When enabled, the nightly sync will not modify this user's supervisor memberships. Their access will still be revoked if they are removed from the user directory.",
      },
      profileModal: {
        title: "Edit User Profile",
        name: "Name",
        shoulderNumber: "Shoulder Number",
        email: "Email",
        update: "Update Profile",
      },
      successMessage: "{{ userName }} successfully updated",
      errorMessage: "Validation failed. Please check your input",
      validationError: "Invalid user roles or organisation data.",
      apiUpdateError: "Failed to update user roles via the API.",
      updateExceptionError: "Unexpected error while updating user roles.",
      bulkCreate: "Bulk Create Users",
      errorBulkCreate: "Failed to bulk create users",
      successBulkCreate: "Users successfully created",
      errorNoOrganisation: "Organisation is required for bulk create",
      organisationId: "Organisation ID",
      uploadCsv: "Upload CSV File",
      supervisorSyncExemptions: {
        title: "Supervisor Override List",
        description:
          "The following users are exempt from automatic supervisor provisioning informed by client systems or active directories. Their supervisor memberships will not be modified by the nightly sync job. If they are removed from the user directory entirely, their application access will still be revoked.",
        bannerTitle: "About this list",
        bannerBody:
          "This list shows users whose supervisor role is managed manually and will not be overridden by automatic supervisor provisioning from client systems or active directories. To add a user to this list, go to the User List tab, open the Edit Memberships modal for the relevant user, assign them a Supervisor role, and tick the 'Exempt from automatic supervisor provisioning' checkbox.",
        name: "Name",
        email: "Email",
        supervisorMemberships: "Supervisor Membership(s)",
        dateAdded: "Date Added to Override List",
        noUsers:
          "No users are currently exempt from automatic supervisor provisioning.",
        removeExemption: "Remove Override",
        removeExemptionSuccess: "Supervisor sync override removed successfully",
        removeExemptionError: "Failed to remove supervisor sync override",
      },
    },
    organisations: {
      searchLabel: "Organisation name or role",
      add: "Add Organisation",
      updateTitle: "Update Organisation",
      createTitle: "Create Organisation",
      update: "Update",
      create: "Create",
      updateConfig: "Update Config",
      delete: "Delete Organisation",
      excludeAsIncidentLocation:
        "Exclude as detention/incident location (organisation can be used as a home base for user profile only)",
      deleteModal: {
        cancel: "Cancel",
        confirm: "Delete",
        title: "Please Confirm",
        message: "Are you sure you want to delete this organisation?",
      },
    },
  },
  s136FormRejected: {
    user: "User",
    email: "Email",
    reason: "Reason",
    rejectedDateTime: "Rejected Date & Time",
    title: "Section 136 Form Rejected",
  },
  contextSelector: {
    welcome: "Welcome to MH Forms.",
    chooseRole: "Please choose the role you require for this session.",
    role: "Role",
    selectOption: "Select an option",
    continue: "Continue",
    invalidMemebership: "Role does not have a corresponding membership",
    setContextError: "Failed to switch role",
  },
  incidentSummary: {
    title: "Incident Summary",
    backToIncidents: "Back to incidents",
    incidentDetails: "Incident Details",
    patientDetails: "Patient Details",
    keyFields: "Key Fields",
    activityTimeline: "Activity Timeline",
    downloadPdf: "Download PDF",
    transfer: "Transfer",
    cancelTransfer: "Cancel Transfer",
    status: "Status",
    incidentType: "Incident Type",
    createdAt: "Created",
    updatedAt: "Last Updated",
    shareCode: "Share Code",
    cadNumber: "CAD / Dispatch Number",
    commandUnit: "Command Unit",
    assignedOfficer: "Assigned Officer",
    placeOfSafety: "Place of Safety",
    timeAtPlaceOfSafety: "Time at Place of Safety",
    timeAtPlaceOfSafetyOngoing: "{{duration}} (ongoing)",
    personName: "Name of Person",
    dateOfBirth: "Date of Birth",
    address: "Address",
    unknown: "Unknown",
    noActivityYet: "No activity recorded yet",
    loadMore: "Load more",
    anonymisedNotice: "Personal details have been anonymised",
    featureNotEnabled: "This feature is not enabled for your organisation",
    entryDetail: "Entry Detail",
    entryDetailEvent: "Event",
    entryDetailTimestamp: "Timestamp",
    entryDetailUser: "User",
    entryDetailOrganisation: "Organisation",
    entryDetailData: "Details",
    entryDetailFields: {
      nhsUser: "NHS User",
      nhsUserEmail: "NHS User Email",
      nhsTeam: "NHS Team",
      nhsTeamEmail: "NHS Team Email",
      nhsOrganisation: "NHS Organisation",
      placeOfSafety: "Place of Safety",
      placeOfSafetyAddress: "Place of Safety Address",
      placeOfSafetyType: "Place of Safety Type",
      isCurrentPlaceOfSafety: "Person Still at This Place of Safety",
      rejectionReason: "Reason for Rejection",
      policePresenceRequested: "Police Presence Requested",
      policePresenceRequestedReason: "Reason for Request",
      remainedAtPlaceOfSafety: "Police Remained at Place of Safety",
      officerInvolved: "Officer Involved",
      createdOnBehalf: "Created on Behalf of Another Officer",
      shareMethod: "Shared By",
      shareMethodEmail: "Email",
      shareMethodShareCode: "Share code",
      ccmNumber: "CCM Number",
      detentionTime: "Time of Detention",
      arrivalTime: "Time Police Entered Place of Safety",
      leftTime: "Time Police Left",
      leftEarlyEndTime: "Time Police Left (Incident Ended Early)",
      change: "{{from}} → {{to}}",
    },
    close: "Close",
    eventCount: "({{count}} events)",
    eventCount_one: "({{count}} event)",
    eventCount_other: "({{count}} events)",
    exportMenu: "Export activity log",
    exportTitle: "Incident Activity Log",
    exportFailed: "Failed to export the activity log",
    exportClipboard: "Copy to clipboard",
    exportCsv: "Download CSV",
    exportPdf: "Download PDF",
    exportCopied: "Activity log copied to clipboard",
    exportCopyFailed: "Failed to copy to clipboard",
    downloadPdfFailed: "Failed to download PDF",
    downloadPdfError: "Error downloading PDF",
    pdfNotAvailable:
      "No PDF is available yet. A PDF is produced once the incident triage has been completed.",
    audit: {
      createIncident: "Incident created",
      updateIncidentData: "Incident data updated",
      formShared: "Form shared with {{posName}}",
      createPlaceOfSafety: "Place of Safety recorded",
      preTriageEndIncident: "Pre-triage end initiated",
      preEndIncident: "End of incident initiated",
      finishForm: "Form completed",
      endIncident: "Incident ended",
      transferIncident: "Incident transferred",
      transferIncidentWithOfficer:
        "Incident transferred to {{receivingOfficer}}",
      resolveTransfer: "Transfer resolved",
      revokeTransfer: "Transfer revoked",
      officerRecordRequestPolicePresence:
        "Police presence recorded - {{presenceDecision}}",
      aspireReviewIncident: "Incident reviewed by NHS",
      aspireAcceptIncident:
        "Incident accepted by {{teamName}} - POS: {{posName}}",
      aspireRejectIncident:
        "Incident rejected by {{teamName}} - Reason: {{reason}}",
      aspireRequestPolicePresence:
        "Police presence requested by NHS ({{teamName}}) - Officer remained: {{remained}}",
      aspireNotRequestPolicePresence: "Police free to leave ({{teamName}})",
      adminEditReportingFields:
        "Reporting fields manually corrected (CCM {{ccmNumber}})",
      adminRelinkPlaceOfSafety:
        "Place of safety re-linked to a curated record (CCM {{ccmNumber}})",
    },
  },
  adminEditReportingFields: {
    launchButton: "Edit reporting fields",
    title: "Edit reporting fields",
    description:
      "Manually correct the agreed reporting times for this incident. This creates a new incident snapshot and is recorded in the audit trail.",
    detentionSection: "Time of detention",
    arrivalSection: "Times police entered place of safety",
    leftSection: "Time police left",
    detentionLabel: "Time of detention",
    arrivalLabel: "Time police entered {{posName}}",
    leftLabel: "Time police left",
    leftEarlyEndLabel: "Time police left (incident ended early)",
    placeOfSafetyFallback: "place of safety",
    dateLabel: "Date",
    timeLabel: "Time",
    noDetentionForm: "This incident has no Section 136 form to edit.",
    noPlaceOfSafetyForms: "This incident has no place of safety forms to edit.",
    noFinishForm: "This incident has no finish form to edit.",
    notSet: "Not set",
    cancel: "Cancel",
    review: "Review changes",
    noChanges: "No changes to save",
    confirmTitle: "Confirm changes",
    confirmDescription:
      "Review the changes below and provide a reason and CCM number. These changes will be recorded in the audit trail and create a new incident snapshot.",
    changeRow: "{{label}}: {{from}} → {{to}}",
    reasonLabel: "Reason for change",
    reasonPlaceholder: "Explain why these times are being corrected",
    ccmNumberLabel: "CCM number",
    ccmNumberPlaceholder: "e.g. CCM-12345",
    confirmButton: "Confirm and save",
    back: "Back",
    saveSuccess: "Reporting fields updated successfully",
    saveError: "Failed to update reporting fields",
  },
  adminRelinkPlaceOfSafety: {
    launchButton: "Re-link place of safety",
    title: "Re-link place of safety",
    description:
      "Link a manually-entered place of safety to the correct curated record (for example, correcting 'Queens Hospital' to 'Queen's Hospital'), and optionally correct its type. This creates a new incident snapshot and is recorded in the audit trail.",
    currentlyRecorded: "Currently recorded",
    pickerLabel: "Link to curated place of safety",
    posType: {
      label: "Place of safety type",
      unchanged: "Leave unchanged",
      unchangedWithCurrent: "Leave unchanged (currently {{current}})",
      options: {
        hbPos136: "Health-based place of safety (136 suite)",
        emergencyDepartment: "Emergency department",
        returnedToMentalHealthUnit: "Returned to mental health unit",
        careHome: "Care home",
        custody: "Custody",
        privateHome: "Private home",
        other: "Other",
      },
    },
    reasonLabel: "Reason for change",
    reasonPlaceholder: "Explain why this place of safety is being re-linked",
    ccmNumberLabel: "CCM number",
    ccmNumberPlaceholder: "e.g. CCM-12345",
    cancel: "Cancel",
    confirmButton: "Confirm and save",
    saveSuccess: "Place of safety re-linked successfully",
    saveError: "Failed to re-link place of safety",
  },
  quickCreateDemoIncident: {
    title: "Quick create incident",
    description:
      "Creates a 136 incident populated up to arrival at the place of safety. Everything except the name and the place of safety is stub data.",
    forenameLabel: "Forename",
    surnameLabel: "Surname",
    placeOfSafetyLabel: "Place of safety",
    cancel: "Cancel",
    create: "Create incident",
    creating: "Creating...",
    failed: "Could not create the incident",
  },
} satisfies Record<string, Record<string, unknown>>;

export default values;
export type Common = typeof values;
